import React, { useState, useEffect, useContext, useRef } from "react";
import { auth, db, functions } from "../firebase/fire";
import { deleteUser, getAuth, signOut } from "firebase/auth";
import { collection, doc, getDocs, updateDoc, addDoc, deleteDoc, setDoc, getDoc, writeBatch, onSnapshot, query, orderBy, limit, deleteField } from "firebase/firestore";
import { useNavigate, useLocation } from "react-router-dom";
import { createUserWithEmailAndPassword, sendEmailVerification, sendPasswordResetEmail, signInWithEmailAndPassword } from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import { useAuth } from "../context/AuthContext";
import DaysDropdown from "./DaysDropdown";
import CoachesDropdown from "./CoachesDropdown";
import StaffReport from "./StaffReport";
import MembershipDetailsTab from "./MembershipDetailsTab";
import MemberReport from "./MemberReport";
import LoadingOverlay from "./LoadingOverlay";
import { Button, Divider, Input, Select } from "antd";
import AgreementUpload from "./AgreementUpload";
import { Tabs } from 'antd';
import Item from "antd/es/list/Item";
import ClassesDropdown from "./ClassesDropdown";
import Modal from "./Modal";
import ConfirmationModal from "./ConfirmationModal";
import { LogoContext } from "./LogoContext";
import { FaCheck, FaEdit, FaTimes, FaUsers, FaUserTie, FaCalendarAlt, FaCog, FaFileAlt, FaChartBar, FaArchive, FaUserShield, FaSignOutAlt, FaChevronDown, FaChevronRight, FaCalendarCheck, FaToggleOn, FaUpload, FaSave, FaCreditCard } from "react-icons/fa";
import ArchivedMembersPage from "./ArchivedMembersPage";
import ArchivedCoachesPage from "./ArchivedCoachesPage";
import CategoryManagement from "./CategoryManagement";
import ClassPerformanceReport from "./ClassPerformanceReport";
import TableControls from "../components/TableControls";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import BookingDetails from "./BookingDetails";
import ClassSchedule from "./ClassSchedule";

export default function AdminDashboard() {
    const [members, setMembers] = useState([]);
    const [coaches, setCoaches] = useState([]);
    const [secAdmins, setsecAdmins] = useState([]);
    const [stripeData, setStripeData] = useState(null);
    const [newCoach, setNewCoach] = useState({ name: "", phone: "", email: "" });
    const [editingMemberId, setEditingMemberId] = useState(null);
    const [freeTrialClasses, setFreeTrialClasses] = useState(0);
    // const [tab, setTab] = useState("membershipDetails");
    const [newStatus, setNewStatus] = useState("");
    const [previousStatus, setPreviousStatus] = useState("");
    const [stripeExportLoading, setStripeExportLoading] = useState(false);
    const [stripeExportMessage, setStripeExportMessage] = useState("");
    const [stripeExportError, setStripeExportError] = useState("");
    const [lastStripeSync, setLastStripeSync] = useState(null);
    const [tab, setTab] = useState("members");
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
    const [expandedMenus, setExpandedMenus] = useState({ members: true, instructors: true, settings: true });
    const [adminName, setAdminName] = useState("");
    const [adminEmail, setAdminEmail] = useState("");
    const [theme, setTheme] = useState('light');
    const [showProfileDropdown, setShowProfileDropdown] = useState(false);
    const navigate = useNavigate();
    const [membershipStartDate, setMembershipStartDate] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [membersLoaded, setMembersLoaded] = useState(false);
    const [classSchedule, setClassSchedule] = useState([]);
    const [isAddingCoach, setIsAddingCoach] = useState(false);
    const { setAddingCoach } = useAuth();
    const [editingClass, setEditingClass] = useState(null);
    const [manualEndDate, setManualEndDate] = useState("");
    const [gymLocation, setGymLocation] = useState({ address: "", latitude: "", longitude: "" });
    const [logoFile, setLogoFile] = useState(null);
    const [logoUrl, setLogoUrl] = useContext(LogoContext);
    // const [logoUrl, setLogoUrl] = useState("");
    const [membershipOptions, setMembershipOptions] = useState([]);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [deleteItemType, setDeleteItemType] = useState(null);
    const location = useLocation();
    const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
    const [selectedMember, setSelectedMember] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedClassesIds, setSelectedClassesIds] = useState([]);
    const [newClassesRemaining, setNewClassesRemaining] = useState(0);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [assigningBarcodeId, setAssigningBarcodeId] = useState(null);
    const [scannedBarcode, setScannedBarcode] = useState("");
    const barcodeInputRef = useRef(null);
    const [assigningBarcodeType, setAssigningBarcodeType] = useState("member");
    const [latestAgreementTimestamp, setLatestAgreementTimestamp] = useState(null);
    const [latestAgreementTimestampInstructor, setLatestAgreementTimestampInstructor] = useState(null);
    const [showPaymentDueOnly, setShowPaymentDueOnly] = useState(false);
    const [editingStripeIds, setEditingStripeIds] = useState({});
    const [originalStripeId, setOriginalStripeId] = useState(null);
    const [selectedMembershipTab, setSelectedMembershipTab] = useState('');
    const [paymentStatusFilter, setPaymentStatusFilter] = useState('All');
    const [categories, setCategories] = useState([]);
    const [selectedMemberCategory, setSelectedMemberCategory] = useState('');


    const regularClasses = classSchedule.filter(c => !c.isSpecialClass);
    const specialClasses = classSchedule.filter(c => c.isSpecialClass);
    const minuteOptions = [0, 15, 30, 45];

    // Sort regular classes by days. For sorting, since days is array, you can sort by the earliest day in the week
    const dayOrder = {
        Monday: 1, Tuesday: 2, Wednesday: 3, Thursday: 4, Friday: 5, Saturday: 6, Sunday: 7
    };

    regularClasses.sort((a, b) => {
        // Find earliest day value in days array for each class
        const aMinDay = Math.min(...a.days.map(day => dayOrder[day] || 99));
        const bMinDay = Math.min(...b.days.map(day => dayOrder[day] || 99));
        return aMinDay - bMinDay;
    });


    useEffect(() => {
        const fetchAgreementTimestamp = async () => {
            const docRef = doc(db, "agreements", "member");
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                const timestamp = docSnap.data().timestamp?.toDate();
                setLatestAgreementTimestamp(timestamp);
            }
        };
        fetchAgreementTimestamp();
    }, []);
    useEffect(() => {
        const fetchAgreementTimestampInstructor = async () => {
            const docRef = doc(db, "agreements", "instructor");
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                const timestamp = docSnap.data().timestamp?.toDate();
                setLatestAgreementTimestampInstructor(timestamp);
            }
        };
        fetchAgreementTimestampInstructor();
    }, []);

    // Close profile dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showProfileDropdown && !event.target.closest('.relative')) {
                setShowProfileDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [showProfileDropdown]);



    const showModal = (message) => {
        setModalMessage(message);
        setModalOpen(true);
    };

    const handleSaveStripeId = async (memberId, stripeId) => {
        try {
            const existingMember = members.find(m => m.id === memberId);
            const stripeIdChanged = existingMember && existingMember.stripeCustomerId !== stripeId;

            const updates = { stripeCustomerId: stripeId };
            if (stripeIdChanged) {
                // Clear stale Stripe-derived fields so old status doesn't linger after unlink/relink
                updates.stripePaymentStatus = deleteField();
                updates.stripeSubscriptionStatus = deleteField();
                updates.stripeCurrentPeriodEnd = deleteField();
            }

            await updateDoc(doc(db, 'members', memberId), updates);
            // Update local state
            setMembers(members.map(m => m.id === memberId ? {
                ...m,
                stripeCustomerId: stripeId,
                ...(stripeIdChanged ? { stripePaymentStatus: undefined, stripeSubscriptionStatus: undefined, stripeCurrentPeriodEnd: undefined } : {})
            } : m));
            setEditingStripeIds({ ...editingStripeIds, [memberId]: false });
            setOriginalStripeId(null);
        } catch (error) {
            console.error('Error saving Stripe ID:', error);
            alert('Error saving Stripe ID: ' + error.message);
        }
    };

    const handleCancelStripeIdEdit = (memberId) => {
        // Revert to original value
        if (originalStripeId !== null) {
            setEditingStripeIds({ ...editingStripeIds, [memberId]: originalStripeId });
        }
        setEditingStripeIds({ ...editingStripeIds, [memberId]: false });
        setOriginalStripeId(null);
    };


    const [statusFilter, setStatusFilter] = useState("All");

    // const filteredMembers = members.filter(member =>
    //     (statusFilter === "All" || member.status === statusFilter) &&
    //     (member.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //         member.email.toLowerCase().includes(searchTerm.toLowerCase()))
    // );

    const filteredMembers = members.filter(
        member =>
            !member.archived && // Only active (handles false, undefined, null)
            (statusFilter === "All" || member.status === statusFilter) &&
            (member.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                member.lastName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                `${member.name ?? ""} ${member.lastName ?? ""}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
                member.email?.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const activeMembers = members.filter(
        member => member.archived === false || member.archived === undefined
    );
    const archivedMembers = members.filter(member => member.archived === true);
    const activeCoaches = coaches.filter(coach => coach.archived === false || coach.archived === undefined);
    const [bookingDays, setBookingDays] = useState(7); // Default to 7 days
    const [hoursBeforeBookingClose, setHoursBeforeBookingClose] = useState(1); // Default to 1 hour
    const [currentPage, setCurrentPage] = useState(1);
    // const [membersPerPage] = useState(7);
    const [membersPerPage, setMembersPerPage] = useState(7);
    const indexOfLastMember = currentPage * membersPerPage;
    const indexOfFirstMember = indexOfLastMember - membersPerPage;

    // Sorting state
    const [sortField, setSortField] = useState("name");
    const [sortDirection, setSortDirection] = useState("asc");

    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const [barcodeError, setBarcodeError] = useState("");
    const [newClass, setNewClass] = useState({
        className: "",
        startTime: "",
        endTime: "",
        days: [],
        coaches: [],
        availableSpots: 0,
        isActive: true,
        isAttendanceReminder: true,
        allAttend: false,
    });

    const toAmPm = (time) => {
        if (!time) return 'AM';
        const parts = time.split(':');
        if (parts.length < 2) return 'AM';
        const hh = parseInt(parts[0], 10);
        return hh >= 12 ? 'PM' : 'AM';
    };

    const applyAmPm = (time, ampm) => {
        // time in HH:MM
        const fallback = '00:00';
        const t = time || fallback;
        const parts = t.split(':');
        if (parts.length < 2) return t;
        let hh = parseInt(parts[0], 10);
        const mm = parts[1];
        if (ampm === 'AM') {
            if (hh === 12) hh = 0;
        } else {
            if (hh < 12) hh = hh + 12;
        }
        return `${String(hh).padStart(2, '0')}:${mm}`;
    };

    const timeStringToDate = (time) => {
        if (!time) return null;
        const parts = time.split(':');
        if (parts.length < 2) return null;
        const hh = parseInt(parts[0], 10);
        const mm = parseInt(parts[1], 10) || 0;
        const d = new Date();
        d.setHours(hh, mm, 0, 0);
        d.setSeconds(0);
        d.setMilliseconds(0);
        return d;
    };

    const dateToTimeString = (date) => {
        if (!date) return '';
        const hh = date.getHours();
        const mm = date.getMinutes();
        return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
    };
    const [memberBookings, setMemberBookings] = useState({});
    const { isSecAdmin, uid, email } = location.state || {};
    const openDetailsModal = (member) => {
        setSelectedMember(member);
        setIsDetailsModalOpen(true);
    };

    const closeDetailsModal = () => {
        setIsDetailsModalOpen(false);
        setSelectedMember(null);
    };

    const [allClasses, setAllClasses] = useState([]);



    const handleStartAssignBarcode = (entityId, currentBarcode = "", entityType = "member") => {
        setAssigningBarcodeId(entityId);
        setAssigningBarcodeType(entityType);
        setScannedBarcode(currentBarcode);
        setTimeout(() => barcodeInputRef.current && barcodeInputRef.current.focus(), 100);
    };

    function getAgreementDate(member) {
        // Prefer no trailing space, but check for common typo
        return member.agreementDate ?? member["agreementDate "] ?? null;
    }
    function getAgreementDateInstructor(instructor) {
        // Prefer no trailing space, but check for common typo
        return instructor.agreementDate ?? instructor["agreementDate "] ?? null;
    }

    const handleBarcodeInput = (e) => {
        setScannedBarcode(e.target.value);
    };
    const handleSaveBarcode = async (entityId, entityType = "member") => {
        const trimmedBarcode = scannedBarcode.trim();
        const trimmedBarcodeLower = trimmedBarcode.toLowerCase();
        if (trimmedBarcodeLower) {
            const isMemberDuplicate = members.some(
                (m) => m.barcode?.toLowerCase() === trimmedBarcodeLower && m.id !== entityId
            );

            const isCoachDuplicate = coaches.some(
                (c) => c.barcode?.toLowerCase() === trimmedBarcodeLower && c.id !== entityId
            );

            if (isMemberDuplicate || isCoachDuplicate) {
                setBarcodeError("This barcode is already assigned to another member or coach.");
                return;
            }
        }

        if (entityType === "member") {
            await updateDoc(doc(db, "members", entityId), { barcode: trimmedBarcode });
            const prevMember = members.find(m => m.id === entityId);
            await logMemberChange(
                entityId,
                { barcode: { before: prevMember?.barcode ?? null, after: trimmedBarcode } },
                "updateBarcode"
            );
            setMembers(members =>
                members.map(m =>
                    m.id === entityId ? { ...m, barcode: trimmedBarcode } : m
                )
            );
        } else if (entityType === "coach") {
            await updateDoc(doc(db, "coaches", entityId), { barcode: trimmedBarcode });
            setCoaches(coaches =>
                coaches.map(c =>
                    c.id === entityId ? { ...c, barcode: trimmedBarcode } : c
                )
            );
        }
        setAssigningBarcodeId(null);
        setScannedBarcode("");
        setBarcodeError("");
    };


    const handleCancelBarcode = () => {
        setAssigningBarcodeId(null);
        setScannedBarcode("");
        setBarcodeError("");
    };
    useEffect(() => {
        const unsubscribe = onSnapshot(collection(db, "members"), (snapshot) => {
            const membersList = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setMembers(membersList);
            setMembersLoaded(true);
        });
        return () => unsubscribe();
    }, []);

    // Fetch admin details
    useEffect(() => {
        const fetchAdminDetails = async () => {
            const currentUser = auth.currentUser;
            if (currentUser) {
                setAdminEmail(currentUser.email || "Admin");
                
                // Try to get admin name from Firestore
                try {
                    const adminQuery = await getDocs(
                        collection(db, "admin")
                    );
                    if (!adminQuery.empty) {
                        const adminData = adminQuery.docs[0].data();
                        setAdminName(adminData.fullName || adminData.name || "Admin");
                    } else {
                        // Check secondary admin
                        const secAdminDoc = await getDoc(doc(db, "secondaryAdmin", currentUser.uid));
                        if (secAdminDoc.exists()) {
                            setAdminName(secAdminDoc.data().fullName || "Admin");
                        } else {
                            setAdminName("Admin");
                        }
                    }
                } catch (error) {
                    console.error("Error fetching admin details:", error);
                    setAdminName("Admin");
                }
            }
        };
        fetchAdminDetails();
    }, []);

    useEffect(() => {
        // Initial one-time fetch
        // Disabled: onSnapshot below already fires immediately with the current
        // data, so this eager fetch just duplicated the same 5 reads on mount.
        // fetchStripeData();

        // Real-time listener so UI updates immediately when exports are written
        const unsubscribe = onSnapshot(collection(db, "stripe_exports"), (snapshot) => {
            const map = {};
            snapshot.docs.forEach(d => {
                // exported docs store their payload under `data` in the functions
                const raw = d.data();
                map[d.id] = Array.isArray(raw.data) ? raw.data : (raw.data || raw);
            });

            setStripeData({
                customers: map.customers || [],
                subscriptions: map.subscriptions || [],
                products: map.products || [],
                prices: map.prices || [],
                paymentIntents: map.paymentIntents || []
            });
        });

        return () => unsubscribe();
    }, []);

    const fetchCoaches = async () => {
        try {
            setIsLoading(true);
            const coachesSnapshot = await getDocs(collection(db, "coaches"));
            const coachesData = coachesSnapshot.docs
                .map((doc) => ({ id: doc.id, ...doc.data() }))
                .filter(coach => coach);
            setCoaches(coachesData);
        } catch (err) {
            console.error("Error fetching coaches:", err);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchCategories = async () => {
        try {
            const snap = await getDocs(collection(db, "categories"));
            setCategories(snap.docs.map(d => ({ id: d.id, ...d.data() })).sort((a, b) => a.name.localeCompare(b.name)));
        } catch (err) {
            console.error("Error fetching categories:", err);
        }
    };

    const fetchStripeData = async () => {
        try {
            const [customersDoc, subscriptionsDoc, productsDoc, pricesDoc, paymentIntentsDoc] = await Promise.all([
                getDoc(doc(db, "stripe_exports", "customers")),
                getDoc(doc(db, "stripe_exports", "subscriptions")),
                getDoc(doc(db, "stripe_exports", "products")),
                getDoc(doc(db, "stripe_exports", "prices")),
                getDoc(doc(db, "stripe_exports", "paymentIntents"))
            ]);

            const data = {
                customers: customersDoc.exists() ? customersDoc.data().data : [],
                subscriptions: subscriptionsDoc.exists() ? subscriptionsDoc.data().data : [],
                products: productsDoc.exists() ? productsDoc.data().data : [],
                prices: pricesDoc.exists() ? pricesDoc.data().data : [],
                paymentIntents: paymentIntentsDoc.exists() ? paymentIntentsDoc.data().data : []
            };

            setStripeData(data);
        } catch (error) {
            console.error("Error fetching stripe data:", error);
        }
    };

    const normalizeEmail = (email) => {
        return typeof email === 'string' ? email.trim().toLowerCase() : "";
    };

    const getStripeCustomerForMember = (member) => {
        if (!stripeData) return null;
        const normalizedMemberEmail = normalizeEmail(member?.email);
        if (member?.stripeCustomerId) {
            return stripeData.customers?.find(c => c.id === member.stripeCustomerId) || null;
        }
        return stripeData.customers?.find(c => normalizeEmail(c.email) === normalizedMemberEmail) || null;
    };

    const getMemberPaymentIntents = (member) => {
        const stripeCustomer = getStripeCustomerForMember(member);
        if (!stripeCustomer || !Array.isArray(stripeData?.paymentIntents)) return [];
        return stripeData.paymentIntents
            .filter(pi => pi.customer === stripeCustomer.id)
            .map(pi => ({ ...pi, paymentDate: new Date(pi.created * 1000) }))
            .sort((a, b) => b.created - a.created);
    };

    const getMemberSubscriptionIntervalDays = (member) => {
        const stripeCustomer = getStripeCustomerForMember(member);
        if (!stripeCustomer) return 30;

        const subscription = stripeData.subscriptions?.find(s => s.customer === stripeCustomer.id);
        const subscriptionItems = subscription?.items?.data || [];
        const priceInfo = subscriptionItems.length > 0
            ? stripeData.prices?.find(p => p.id === subscriptionItems[0].price.id)
            : null;

        const interval = priceInfo?.recurring?.interval;
        const intervalCount = priceInfo?.recurring?.interval_count || 1;
        const intervalMap = {
            day: 1,
            week: 7,
            month: 30,
            year: 365
        };
        return (intervalMap[interval] || 30) * intervalCount;
    };

    const getLatestRelevantPayment = (member) => {
        const payments = getMemberPaymentIntents(member);
        if (!payments.length) return null;

        const windowDays = getMemberSubscriptionIntervalDays(member);
        const windowStart = new Date();
        windowStart.setDate(windowStart.getDate() - windowDays);

        return payments.find(pi => pi.paymentDate >= windowStart) || payments[0];
    };

    const handleManualPaymentStatusChange = async (memberId, status) => {
        try {
            await updateDoc(doc(db, 'members', memberId), { manualPaymentStatus: status });
            setMembers(prevMembers => prevMembers.map(m => m.id === memberId ? { ...m, manualPaymentStatus: status } : m));
        } catch (error) {
            console.error('Error saving manual payment status:', error);
            alert('Could not save manual payment status: ' + error.message);
        } 
    };

    const buildMemberBookingsFromClasses = (classesList) => {
        const bookingsData = {};
        classesList.forEach((classData) => {
            if (classData.bookings) {
                Object.entries(classData.bookings).forEach(([date, booking]) => {
                    if (booking && booking.memberIds && Array.isArray(booking.memberIds)) {
                        booking.memberIds.forEach((memberId) => {
                            if (!bookingsData[memberId]) bookingsData[memberId] = [];
                            bookingsData[memberId].push({
                                className: classData.className,
                                date: date,
                                time: `${classData.startTime} - ${classData.endTime}`
                            });
                        });
                    }
                });
            }
        });
        return bookingsData;
    };

    useEffect(() => {
        setIsLoading(true);
        const unsubscribe = onSnapshot(collection(db, "classSchedule"), (snapshot) => {
            const rawClasses = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

            setAllClasses(rawClasses);

            const scheduleList = rawClasses.map((data) => ({
                id: data.id,
                className: data.className || '',
                startTime: data.startTime || '',
                endTime: data.endTime || '',
                days: data.days || [],
                coaches: data.coaches || [],
                availableSpots: data.availableSpots || 0,
                isSpecialClass: data.isSpecialClass || false,
                specialClassDate: data.specialClassDate || null,
                isActive: data.isActive !== undefined ? data.isActive : true,
                isAttendanceReminder: data.isAttendanceReminder !== undefined ? data.isAttendanceReminder : true,
                allAttend: data.allAttend || false,
            }));

            setClassSchedule(scheduleList);
            setMemberBookings(buildMemberBookingsFromClasses(rawClasses));
            setIsLoading(false);
        }, (error) => {
            console.error("Error listening to class schedule:", error);
            setIsLoading(false);
        });

        return () => unsubscribe();
    }, []);


    const getClassNamesFromIds = (ids) => {
        if (!ids || !Array.isArray(ids)) return [];
        return allClasses
            .filter(cls => ids.includes(cls.id))
            .map(cls => cls.className);
    };



    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const [coachesSnapshot, secAdminSnapshot, categoriesSnapshot] = await Promise.all([
                    getDocs(collection(db, "coaches")),
                    getDocs(collection(db, "secondaryAdmin")),
                    getDocs(collection(db, "categories"))
                ]);

                const coachesData = coachesSnapshot.docs
                    .map((doc) => ({ id: doc.id, ...doc.data() }))
                    .filter(coach => coach);
                setCoaches(coachesData);

                const secAdminList = secAdminSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
                setsecAdmins(secAdminList);

                setCategories(categoriesSnapshot.docs.map(d => ({ id: d.id, ...d.data() })).sort((a, b) => a.name.localeCompare(b.name)));
            } catch (error) {
                console.error("Error fetching data: ", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleConfirmCoach = async (coachId) => {
        await updateDoc(doc(db, "coaches", coachId), { isCoach: true });
        alert("Instructor confirmed successfully!");
        setIsLoading(false);
    };

    const handleSignOut = async () => {
        try {
            await signOut(auth);
            navigate("/member-login");
        } catch (error) {
            console.error("Error signing out: ", error);
        }
    };

    const calculateEndDate = (startDate, status) => {
        const start = new Date(startDate);
        switch (status) {
            // case "Gold Membership":
            // case "Silver Membership":
            //     return new Date(start.setFullYear(start.getFullYear() + 1));
            case "Concession Card":
                return new Date(start.setMonth(start.getMonth() + 3));
            default:
                return null;
        }
    };

    const handleMemberClassChangeOld = async (memberId, selectedClassIds) => {
        await updateDoc(doc(db, "members", memberId), {
            eligibleClasses: selectedClassIds,
            hasCustomClasses: true
        });
        const memberSnap = await getDoc(doc(db, "members", memberId));
    };

    const handleMemberClassChangeold1 = async (memberId, selectedClassIds) => {
        await updateDoc(doc(db, "members", memberId), {
            eligibleClasses: selectedClassIds,
            hasCustomClasses: true
        });
        // update local state so UI reflects DB immediately:
        setMembers(prev => prev.map(m => m.id === memberId ? { ...m, eligibleClasses: selectedClassIds, hasCustomClasses: true } : m));
    };

    const handleMemberClassChange = async (memberId, selectedClassIds) => {
        try {
            const memberRef = doc(db, "members", memberId);
            await updateDoc(memberRef, {
                eligibleClasses: selectedClassIds,
                hasCustomClasses: true, // mark as manual edit
            });

            // Immediately update local state to ensure UI is in sync
            setMembers(prev =>
                prev.map(m =>
                    m.id === memberId
                        ? { ...m, eligibleClasses: selectedClassIds, hasCustomClasses: true }
                        : m
                )
            );
        } catch (error) {
            console.error("Error updating member classes:", error);
            showModal("Failed to update member classes");
        }
    };


    // store previous selections to allow Cancel to restore them
    const [prevSelectedClasses, setPrevSelectedClasses] = useState([]);

    const startEditMember = (member) => {
        setEditingMemberId(member.id);
        const initial = Array.isArray(member.eligibleClasses) ? member.eligibleClasses : [];
        setSelectedClassesIds(initial);
        setPrevSelectedClasses(initial);
        // optionally set any other edit state (e.g. membershipStartDate, newStatus)
    };



    const handleUpdateMemberStatus = async (memberId) => {
        try {
            setIsLoading(true);
            const memberRef = doc(db, "members", memberId);
            const startDate = new Date(membershipStartDate);
            const docSnap = await getDoc(memberRef);

            const currentMemberData = docSnap.data();

            // Fetch the selected membership details
            const membershipDetailsSnapshot = await getDocs(collection(db, "membershipDetails"));
            const membershipDetails = membershipDetailsSnapshot.docs
                .find(doc => doc.data().name === newStatus)?.data();

            if (!membershipDetails) {
                alert("Invalid membership status");
                setIsLoading(false);
                return;

            }
            let updatedFields = {};
            // Update status only if it has changed
            if (newStatus !== currentMemberData.status) {
                updatedFields.status = newStatus;
            }
            // Update start date only if it has changed
            if (membershipStartDate) {
                const startDate = new Date(membershipStartDate);
                if (startDate !== currentMemberData.membershipStartDate) {
                    updatedFields.membershipStartDate = startDate;
                }
            }
            // Update end date
            if (manualEndDate) {
                updatedFields.membershipEndDate = new Date(manualEndDate);
            } else if (membershipDetails.isUnlimitedDuration) {
                updatedFields.membershipEndDate = null;
            } else if (updatedFields.membershipStartDate) {
                const endDate = new Date(updatedFields.membershipStartDate);
                endDate.setDate(endDate.getDate() + (parseInt(membershipDetails.duration) * 7));
                updatedFields.membershipEndDate = endDate;
            }
            let endDate;

            // if (newStatus !== currentMemberData.status) {
            //     // const totalClasses = parseInt(membershipDetails.totalClasses);
            //     // updatedFields.classesRemaining = !isNaN(totalClasses) && membershipDetails.totalClasses > 0 ? membershipDetails.totalClasses - currentMemberData.totalClassesAttended :
            //     //     'Unlimited';
            //     const totalClassesRaw = membershipDetails.totalClasses;
            //     let classesRemainingValue;

            //     if (totalClassesRaw === "" || totalClassesRaw === null || totalClassesRaw === undefined) {
            //         classesRemainingValue = 'Unlimited';
            //     } else {
            //         const totalClassesParsed = parseInt(totalClassesRaw);
            //         if (!isNaN(totalClassesParsed) && totalClassesParsed > 0) {
            //             // Calculate remaining classes
            //             classesRemainingValue = totalClassesParsed - (currentMemberData.totalClassesAttended || 0);
            //             // Clamp to zero minimum
            //             if (classesRemainingValue < 0) classesRemainingValue = 0;
            //         } else {
            //             classesRemainingValue = 'Unlimited';
            //         }
            //     }

            //     updatedFields.classesRemaining = classesRemainingValue;
            //     updatedFields.totalClassesAttended = 0;
            //     updatedFields.weeklyClassesAttended = 0;
            //     updatedFields.lastWeekReset = new Date();
            //     updatedFields.lastAttendanceDate = null;

            // }
            let calculatedClassesRemaining;
            if (newStatus !== currentMemberData.status) {
                const totalClassesRaw = membershipDetails.totalClasses;

                let classesRemainingValue;

                if (!totalClassesRaw || totalClassesRaw === "") {
                    classesRemainingValue = 'Unlimited';

                } else {
                    const totalClassesParsed = parseInt(totalClassesRaw, 10);

                    if (!isNaN(totalClassesParsed) && totalClassesParsed >= 0) {
                        classesRemainingValue = totalClassesParsed - (currentMemberData.totalClassesAttended || 0);

                        if (classesRemainingValue < 0) classesRemainingValue = 0;
                    } else {
                        classesRemainingValue = 'Unlimited';
                    }
                }

                calculatedClassesRemaining = classesRemainingValue;
                updatedFields.classesRemaining = classesRemainingValue;
                updatedFields.totalClassesAttended = 0;
                updatedFields.weeklyClassesAttended = 0;
                updatedFields.lastWeekReset = new Date();
                updatedFields.lastAttendanceDate = null;
            }


            updatedFields.eligibleClasses = selectedClassesIds;
            updatedFields.classesPerWeek = membershipDetails.classesPerWeek;
            updatedFields.totalClassesAllowed = membershipDetails.isUnlimitedClasses ? 'Unlimited' :
                (parseInt(membershipDetails.classesPerWeek) * parseInt(membershipDetails.duration));
            // if (typeof newClassesRemaining !== 'undefined' && newClassesRemaining !== null) {
            //     updatedFields.classesRemaining = newClassesRemaining;
            // }
            // After calculating classesRemainingValue as per membership totalClasses


            if (typeof newClassesRemaining !== "undefined" && newClassesRemaining !== null) {
                const newVal = typeof newClassesRemaining === "string" ? newClassesRemaining.trim().toLowerCase() : newClassesRemaining;

                const newValIsValid =
                    newVal === "unlimited" ||
                    (typeof newVal === "number" && newVal >= 0) ||
                    (typeof newVal === "string" && /^\d+$/.test(newVal));

                if (newValIsValid) {
                    let overrideVal = newVal === "unlimited" ? "Unlimited" : parseInt(newVal, 10);

                    // Only override if different from calculated value
                    const calculatedValComparable = typeof calculatedClassesRemaining === "string" ? calculatedClassesRemaining.toLowerCase() : calculatedClassesRemaining;

                    if (overrideVal !== calculatedValComparable) {
                        calculatedClassesRemaining = overrideVal;
                    }
                    // else leave calculatedClassesRemaining unchanged
                }
            }
            if (typeof calculatedClassesRemaining !== "undefined" && calculatedClassesRemaining !== null) {
                updatedFields.classesRemaining = calculatedClassesRemaining;
            }

            await updateDoc(memberRef, updatedFields);

            const changesObj = {};
            Object.entries(updatedFields).forEach(([field, afterValue]) => {
                const beforeValue = currentMemberData[field] ?? null;
                if (
                    (beforeValue instanceof Date && afterValue instanceof Date)
                        ? beforeValue.getTime() !== afterValue.getTime()
                        : beforeValue !== afterValue
                ) {
                    changesObj[field] = { before: beforeValue, after: afterValue };
                }
            });
            if (Object.keys(changesObj).length > 0) {
                await logMemberChange(memberId, changesObj, "Updated Member Data");
            }


            const membersSnapshot = await getDocs(collection(db, "members"));
            const membersList = membersSnapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));
            setMembers(membersList);
            setEditingMemberId(null);
            setNewStatus("");
            setPreviousStatus("");
            setMembershipStartDate("");
            setIsLoading(false);
        } catch (error) {

            setIsLoading(false);
            console.error("Error updating member status: ", error);
        }
    };
    // Disabled: duplicated the fetchMembershipOptions() effect further below
    // (both populated membershipOptions from the same "membershipDetails" collection).
    // useEffect(() => {
    //     const fetchMembershipOptions = async () => {
    //         setIsLoading(true);
    //         const membershipSnapshot = await getDocs(collection(db, "membershipDetails"));
    //         const options = membershipSnapshot.docs.map(doc => ({
    //             id: doc.id,
    //             name: doc.data().name
    //         }));
    //         setMembershipOptions(options);
    //         setIsLoading(false);
    //     };
    //     fetchMembershipOptions();
    // }, []);

    const handleCancelEditOld = () => {
        setEditingMemberId(null);
        setNewStatus(previousStatus);
        setMembershipStartDate("");
    };

    const handleCancelEdit = () => {
        // revert selectedClassesIds to previous DB state
        setSelectedClassesIds(prevSelectedClasses || []);
        setEditingMemberId(null);
        setNewStatus(previousStatus);
        setMembershipStartDate("");
    };

    const handleUpdateCoach = async (coachId, updatedCoach) => {
        try {
            const coachRef = doc(db, "coaches", coachId);
            await updateDoc(coachRef, updatedCoach);
            const updatedCoaches = coaches.map(coach =>
                coach.id === coachId ? { ...coach, ...updatedCoach } : coach
            );
            setCoaches(updatedCoaches);
        } catch (error) {
            console.error("Error updating coach: ", error);
        }
    };

    const handleUpdateCoachCategories = async (coachId, selectedCategories) => {
        try {
            await updateDoc(doc(db, "coaches", coachId), { categories: selectedCategories });
            setCoaches(prev => prev.map(c => c.id === coachId ? { ...c, categories: selectedCategories } : c));
        } catch (error) {
            console.error("Error updating coach categories:", error);
        }
    };

    const handleUpdateMemberCategory = async (memberId, category) => {
        try {
            await updateDoc(doc(db, "members", memberId), { category });
            setMembers(prev => prev.map(m => m.id === memberId ? { ...m, category } : m));
        } catch (error) {
            console.error("Error updating member category:", error);
        }
    };


    const addClassToAllMembers = async (classId) => {
        const membersSnapshot = await getDocs(collection(db, "members"));
        const batch = writeBatch(db);

        membersSnapshot.forEach(docSnap => {
            const member = docSnap.data();
            const eligibleClasses = Array.isArray(member.eligibleClasses) ? member.eligibleClasses : [];
            // Add class to ALL members, including those with hasCustomClasses: true
            if (!eligibleClasses.includes(classId)) {
                batch.update(doc(db, "members", docSnap.id), {
                    eligibleClasses: [...eligibleClasses, classId]
                });
            }
        });

        await batch.commit();
    };

    const removeClassFromAllMembersold = async (classId) => {
        const membersSnapshot = await getDocs(collection(db, "members"));
        const batch = writeBatch(db);

        membersSnapshot.forEach(docSnap => {
            const member = docSnap.data();
            // Only update if hasCustomClasses is not true
            if (!member.hasCustomClasses) {
                const eligibleClasses = Array.isArray(member.eligibleClasses) ? member.eligibleClasses : [];
                if (eligibleClasses.includes(classId)) {
                    batch.update(doc(db, "members", docSnap.id), {
                        eligibleClasses: eligibleClasses.filter(id => id !== classId)
                    });
                }
            }
        });

        await batch.commit();
    };

    const removeClassFromAllMembers = async (classId) => {
        const membersSnapshot = await getDocs(collection(db, "members"));
        const batch = writeBatch(db);

        membersSnapshot.forEach((docSnap) => {
            const data = docSnap.data();
            const eligible = Array.isArray(data.eligibleClasses)
                ? data.eligibleClasses
                : [];
            if (eligible.includes(classId)) {
                batch.update(doc(db, "members", docSnap.id), {
                    eligibleClasses: eligible.filter((id) => id !== classId),
                });
            }
        });

        await batch.commit();
    };

    // Archive member
    const handleArchiveMember = async (memberId) => {
        setIsLoading(true);
        await updateDoc(doc(db, "members", memberId), { archived: true });
        const prevMember = members.find(m => m.id === memberId);
        await logMemberChange(
            memberId,
            { archived: { before: prevMember?.archived ?? false, after: true } },
            "Archived"
        );
        setMembers((prev) =>
            prev.map((m) => (m.id === memberId ? { ...m, archived: true } : m))
        );
        setIsLoading(false);
        showModal("Member archived successfully");
    };
    // Archive coach
    const handleArchiveCoach = async (coachId) => {
        try {
            setIsLoading(true);
            await updateDoc(doc(db, "coaches", coachId), { archived: true });
            const prevCoach = coaches.find(c => c.id === coachId);
            // Log coach change if desired
            await addDoc(collection(db, "coachAuditLog"), {
                coachId,
                changes: [{ field: 'archived', before: prevCoach?.archived ?? false, after: true }],
                action: 'Archived',
                timestamp: new Date(),
                changedBy: email,
            });
            setCoaches((prev) => prev.map((c) => (c.id === coachId ? { ...c, archived: true } : c)));
            showModal("Instructor archived successfully");
        } catch (error) {
            console.error("Error archiving coach:", error);
        } finally {
            setIsLoading(false);
        }
    };
    const refreshMembers = async () => {
        await new Promise(resolve => setTimeout(resolve, 500));
        const snap = await getDocs(collection(db, "members"));
        setMembers(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    };

    const handleAddOrUpdateClass = async (e) => {
        e.preventDefault();
        try {
            // Check for duplicate classes
            const isDuplicate = classSchedule.some(cls =>
                cls.className === newClass.className &&
                cls.startTime === newClass.startTime &&
                cls.endTime === newClass.endTime &&
                (newClass.isSpecialClass
                    ? cls.specialClassDate === newClass.specialClassDate
                    : cls.days.some(day => newClass.days.includes(day))) &&
                cls.id !== (editingClass ? editingClass.id : null)
            );

            if (isDuplicate) {
                alert("A class with the same name, time, and day/date already exists.");
                setIsLoading(false);
                return;
            }

            const classData = {
                ...newClass,
                days: newClass.isSpecialClass ? [] : newClass.days,
                specialClassDate: newClass.isSpecialClass ? newClass.specialClassDate : null,
                allAttend: newClass.allAttend
            };

            if (editingClass) {
                await updateDoc(doc(db, "classSchedule", editingClass.id), classData);
                setClassSchedule(classSchedule.map(cls => cls.id === editingClass.id ? { ...cls, ...classData } : cls));
                if (editingClass.allAttend && !classData.allAttend) {
                    await removeClassFromAllMembers(editingClass.id);
                    // await new Promise(resolve => setTimeout(resolve, 500));
                    // const membersSnapshot = await getDocs(collection(db, "members"));
                    // const membersList = membersSnapshot.docs.map((doc) => ({
                    //     id: doc.id,
                    //     ...doc.data(),
                    // }));
                    // setMembers(membersList);
                    await refreshMembers();
                }
                if (!editingClass.allAttend && classData.allAttend) {
                    await addClassToAllMembers(editingClass.id);
                    // await new Promise(resolve => setTimeout(resolve, 500));
                    // const membersSnapshot = await getDocs(collection(db, "members"));
                    // const membersList = membersSnapshot.docs.map((doc) => ({
                    //     id: doc.id,
                    //     ...doc.data(),
                    // }));
                    // setMembers(membersList);
                    await refreshMembers();
                }
                setEditingClass(null);
            } else {
                const docRef = await addDoc(collection(db, "classSchedule"), classData);
                setClassSchedule([...classSchedule, { id: docRef.id, ...classData }]);
                if (classData.allAttend) {
                    await addClassToAllMembers(docRef.id);
                    const membersSnapshot = await getDocs(collection(db, "members"));
                    const membersList = membersSnapshot.docs.map((doc) => ({
                        id: doc.id,
                        ...doc.data(),
                    }));
                    setMembers(membersList);
                }
            }

            setNewClass({
                className: "",
                startTime: "",
                endTime: "",
                days: [],
                coaches: [],
                availableSpots: 0,
                isSpecialClass: false,
                specialClassDate: null,
                allAttend: false

            });
        } catch (error) {
            console.error("Error adding/updating class: ", error);
        }
    };
    const handleSaveClass = async (classId, updatedClass) => {
        try {
            const classRef = doc(db, "classSchedule", classId);
            const prevClass = classSchedule.find(cls => cls.id === classId);

            // Filter out undefined values to avoid Firestore errors
            const cleanedClass = Object.fromEntries(
                Object.entries(updatedClass).filter(([_, v]) => v !== undefined)
            );

            // Save updated class
            await updateDoc(classRef, cleanedClass);

            setClassSchedule(classSchedule.map(cls =>
                cls.id === classId ? { ...cls, ...cleanedClass } : cls
            ));

            // --- Handle All Attend logic ---
            if (prevClass && prevClass.allAttend !== cleanedClass.allAttend) {
                const membersSnapshot = await getDocs(collection(db, "members"));
                const batch = writeBatch(db);

                membersSnapshot.forEach((docSnap) => {
                    const member = docSnap.data();
                    const eligible = Array.isArray(member.eligibleClasses)
                        ? member.eligibleClasses
                        : [];

                    // Apply allAttend changes to ALL members (including those with hasCustomClasses: true)
                    if (cleanedClass.allAttend) {
                        //  Add this class to everyone
                        if (!eligible.includes(classId)) {
                            batch.update(doc(db, "members", docSnap.id), {
                                eligibleClasses: [...eligible, classId]
                            });
                        }
                    } else {
                        //  Remove this class from everyone
                        if (eligible.includes(classId)) {
                            batch.update(doc(db, "members", docSnap.id), {
                                eligibleClasses: eligible.filter((id) => id !== classId)
                            });
                        }
                    }
                });

                await batch.commit();
                await refreshMembers();
            }

            setEditingClass(null);
        } catch (error) {
            console.error("Error updating class:", error);
        }
    };

    const handleSaveClassOld1 = async (classId, updatedClass) => {
        try {
            await updateDoc(doc(db, "classSchedule", classId), updatedClass);
            setClassSchedule(classSchedule.map(cls => (cls.id === classId ? updatedClass : cls)));
            setEditingClass(null);
        } catch (error) {
            console.error("Error updating class:", error);
        }
    };

    const logMemberChange = async (memberId, changesObj, actionType) => {
        const changeEntries = Object.entries(changesObj).map(([field, { before, after }]) => ({
            field,
            before,
            after
        }));

        await addDoc(collection(db, "memberAuditLog"), {
            memberId,
            changes: changeEntries,
            action: actionType,
            timestamp: new Date(),
            changedBy: email,
        });
    };

    const handleSaveClassOld = async (classId) => {
        const classRow = document.querySelector(`tr[data-id="${classId}"]`);
        if (!classRow) {
            console.error("Class row not found");
            return;
        }

        const isSpecialClass = classRow.querySelector('select[name="isSpecialClass"]')?.value === 'yes';
        const allAttend = classRow.querySelector('select[name="allAttend"]')?.value === 'yes';
        const updatedClass = {
            className: classRow.querySelector('input[name="className"]')?.value || '',
            startTime: classRow.querySelector('input[name="startTime"]')?.value || '',
            endTime: classRow.querySelector('input[name="endTime"]')?.value || '',
            days: isSpecialClass ? [] : Array.from(classRow.querySelectorAll('input[name="days"]:checked')).map(input => input.value),
            coaches: classSchedule.find(cls => cls.id === classId).coaches || [],
            availableSpots: parseInt(classRow.querySelector('input[name="availableSpots"]')?.value || '0', 10),
            isSpecialClass: isSpecialClass,
            specialClassDate: isSpecialClass ? classRow.querySelector('input[name="specialClassDate"]')?.value || null : null,
            allAttend: allAttend,
        };

        try {
            const prevClass = classSchedule.find(cls => cls.id === classId);
            await updateDoc(doc(db, "classSchedule", classId), updatedClass);
            setClassSchedule(classSchedule.map(cls => cls.id === classId ? { ...cls, ...updatedClass } : cls));
            setEditingClass(null);
            if (!prevClass.allAttend && updatedClass.allAttend) {
                await addClassToAllMembers(classId);
                const membersSnapshot = await getDocs(collection(db, "members"));
                const membersList = membersSnapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setMembers(membersList);
            }
            if (prevClass.allAttend && !updatedClass.allAttend) {
                await removeClassFromAllMembers(classId);
                const membersSnapshot = await getDocs(collection(db, "members"));
                const membersList = membersSnapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setMembers(membersList);
            }
        } catch (error) {
            console.error("Error updating class: ", error);
        }
    };

    const handleEditClass = (classItem) => {
        setEditingClass(classItem);
    };


    const handleDeleteClass = async (classId) => {
        const classToDelete = classSchedule.find(c => c.id === classId);
        const className = classToDelete?.className || 'this class';
        if (window.confirm(`Are you sure you want to delete class "${className}"?`)) {
            try {
                await deleteDoc(doc(db, "classSchedule", classId));
                setClassSchedule(classSchedule.filter(classItem => classItem.id !== classId));
            } catch (error) {
                console.error("Error deleting class: ", error);
            }
        }
    };


    const handleToggleCoach = async (coachId) => {
        try {
            const coachToUpdate = coaches.find(coach => coach.id === coachId);
            const updatedIsCoach = !coachToUpdate.isCoach;

            // Update the Firebase document
            const coachRef = doc(db, "coaches", coachId);
            await updateDoc(coachRef, {
                isCoach: updatedIsCoach
            });

            // Update the local state
            setCoaches(coaches.map(coach =>
                coach.id === coachId ? { ...coach, isCoach: updatedIsCoach } : coach
            ));
            alert("Instructor status updated");
            setIsLoading(false);
        } catch (error) {
            console.error("Error updating Instructor status:", error);
            // Handle the error (e.g., show an error message to the user)
        }
    };
    const handleInactiveCoach = async (coachId) => {
        try {
            const coachToUpdate = coaches.find(coach => coach.id === coachId);
            const updatedIsActiveCoach = !coachToUpdate.isActiveCoach;

            // Update the Firebase document
            const coachRef = doc(db, "coaches", coachId);
            await updateDoc(coachRef, {
                isActiveCoach: updatedIsActiveCoach
            });

            // Update the local state
            setCoaches(coaches.map(coach =>
                coach.id === coachId ? { ...coach, isActiveCoach: updatedIsActiveCoach } : coach
            ));
            alert("Instructor Active Status updated");
            setIsLoading(false);
        } catch (error) {
            console.error("Error updating Instructor status:", error);
            // Handle the error (e.g., show an error message to the user)
        }
    };

    const handleToggleSecAdmin = async (secAdminId) => {
        try {
            const secAdminToUpdate = secAdmins.find(secAdmin => secAdmin.id === secAdminId);
            const updatedIsSecAdmin = !secAdminToUpdate.isSecAdmin;

            // Update the Firebase document
            const secAdminRef = doc(db, "secondaryAdmin", secAdminId);
            await updateDoc(secAdminRef, {
                isSecAdmin: updatedIsSecAdmin
            });

            // Update the local state
            setsecAdmins(secAdmins.map(secAdmin =>
                secAdmin.id === secAdminId ? { ...secAdmin, isSecAdmin: updatedIsSecAdmin } : secAdmin
            ));
            alert("Assistant Admin status updated");
            setIsLoading(false);
        } catch (error) {
            console.error("Error updating Instructor status:", error);
            // Handle the error (e.g., show an error message to the user)
        }
    };
    const handleInactiveSecAdmin = async (secAdminId) => {
        try {
            const secAdminToUpdate = secAdmins.find(secAdmin => secAdmin.id === secAdminId);
            const updatedIsActiveAdmin = !secAdminToUpdate.isActiveAdmin;

            // Update the Firebase document
            const secAdminRef = doc(db, "secondaryAdmin", secAdminId);
            await updateDoc(secAdminRef, {
                isActiveAdmin: updatedIsActiveAdmin
            });

            // Update the local state
            setsecAdmins(secAdmins.map(secAdmin =>
                secAdmin.id === secAdminId ? { ...secAdmin, isActiveAdmin: updatedIsActiveAdmin } : secAdmin
            ));
            alert("Assistant Admin Active Status updated");
            setIsLoading(false);
        } catch (error) {
            console.error("Error updating Instructor status:", error);
            // Handle the error (e.g., show an error message to the user)
        }
    };
    const handleLogoUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setLogoFile(file);
            setLogoUrl(URL.createObjectURL(file));
        }
    };

    const handleSaveLogo = async () => {
        if (!logoFile) {
            alert("Please select a logo file first.");
            setIsLoading(false);
            return;
        }

        try {
            const reader = new FileReader();
            reader.onloadend = async () => {
                const base64String = reader.result;
                await setDoc(doc(db, "settings", "logo"), { url: base64String });
                localStorage.removeItem('logoUrl');
                setLogoUrl('');
                alert("Logo uploaded successfully!");
                setIsLoading(false);

            };
            reader.readAsDataURL(logoFile);
        } catch (error) {
            console.error("Error uploading logo:", error);
            alert("Failed to upload logo.");
            setIsLoading(false);
        }
    };
    useEffect(() => {
        const fetchSettings = async () => {
            try {
                setIsLoading(true);
                const locationDoc = await getDoc(doc(db, "settings", "location"));
                if (locationDoc.exists()) {
                    const data = locationDoc.data();
                    setGymLocation({
                        address: data.address || "",
                        latitude: data.latitude || "",
                        longitude: data.longitude || ""
                    });
                    setIsLoading(false);
                }

                const logoDoc = await getDoc(doc(db, "settings", "logo"));
                if (logoDoc.exists()) {
                    setLogoUrl(logoDoc.data().url);
                    setIsLoading(false);
                }
            } catch (error) {
                setIsLoading(false);
                console.error("Error fetching settings:", error);
            }
        };

        fetchSettings();
    }, []);
    // Disabled: duplicated the logo fetch already done inside fetchSettings() above
    // (both fetch "settings/logo" and call setLogoUrl with the same value).
    // useEffect(() => {
    //     const fetchLogo = async () => {
    //         try {
    //             const logoDoc = await getDoc(doc(db, "settings", "logo"));
    //             if (logoDoc.exists()) {
    //                 setLogoUrl(logoDoc.data().url);
    //             }
    //         } catch (error) {
    //             console.error("Error fetching logo:", error);
    //         }
    //     };
    //     fetchLogo();
    // }, []);

    //Membership
    useEffect(() => {
        fetchMembershipOptions();
    }, []);

    const fetchMembershipOptions = async () => {
        try {
            const membershipSnapshot = await getDocs(collection(db, "membershipDetails"));
            const options = membershipSnapshot.docs.map(doc => ({
                id: doc.id,
                name: doc.data().name
            }));
            setMembershipOptions(options);
        } catch (error) {
            console.error("Error fetching membership options:", error);
        }
    };
    const [gymAddress, setGymAddress] = useState("");

    const handleConfirmDelete = async () => {
        try {
            setIsLoading(true);
            if (deleteItemType === 'member') {
                await deleteDoc(doc(db, "members", deleteItemId));
                setMembers(members.filter(member => member.id !== deleteItemId));
            } else if (deleteItemType === 'instructor') {
                await deleteDoc(doc(db, "coaches", deleteItemId));
                setCoaches(coaches.filter(coach => coach.id !== deleteItemId));
            }
            showModal("User deleted successfully");
        } catch (error) {
            console.error(`Error deleting ${deleteItemType}:`, error);
        } finally {
            setIsDeleteModalOpen(false);
            setDeleteItemId(null);
            setDeleteItemType(null);
            setIsLoading(false);
        }
    };



    const handleSaveBookingDays = async () => {
        try {
            await updateDoc(doc(db, "settings", "booking"), {
                daysAllowedPrior: parseInt(bookingDays),
                hoursBeforeBookingClose: parseInt(hoursBeforeBookingClose)
            });
            alert("Booking settings saved successfully!");
            setIsLoading(false);
        } catch (error) {
            console.error("Error saving booking settings:", error);
            alert("Failed to save booking settings. Please try again.");
            setIsLoading(false);
        }
    };

    const handleExportStripeData = async () => {
        setStripeExportLoading(true);
        setStripeExportMessage("");
        setStripeExportError("");

        try {
            const syncFunction = httpsCallable(functions, 'triggerStripeSync');
            const syncResult = await syncFunction();

            if (syncResult.data?.success) {
                const syncedMembers = syncResult.data?.sync?.membersUpdated || 0;
                setStripeExportMessage(`✓ Sync complete! Updated ${syncedMembers} member payment statuses.`);
            } else {
                setStripeExportError('Stripe sync failed.');
            }
        } catch (error) {
            console.error('Stripe export error:', error);
            setStripeExportError(error.message || 'Stripe sync failed.');
        } finally {
            setStripeExportLoading(false);
        }
    };

    useEffect(() => {
        const fetchBookingSettings = async () => {
            setIsLoading(true);
            const bookingDoc = await getDoc(doc(db, "settings", "booking"));
            if (bookingDoc.exists()) {
                setBookingDays(bookingDoc.data().daysAllowedPrior || 7);
                setHoursBeforeBookingClose(bookingDoc.data().hoursBeforeBookingClose || 1);
                setIsLoading(false);
            }
        };
        fetchBookingSettings();
    }, []);

    // Real-time listener for last Stripe sync time
    useEffect(() => {
        const q = query(collection(db, 'payment_sync_history'), orderBy('timestamp', 'desc'), limit(1));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            if (!snapshot.empty) {
                const lastSync = snapshot.docs[0].data().timestamp?.toDate();
                setLastStripeSync(lastSync);
            }
        }, () => {});
        return () => unsubscribe();
    }, []);

    const handleToggleClass = async (classId) => {
        try {
            const classRef = doc(db, "classSchedule", classId);
            const classDoc = await getDoc(classRef);
            const currentClass = classDoc.data();

            await updateDoc(classRef, {
                isActive: !currentClass.isActive
            });

            setClassSchedule(prevSchedule =>
                prevSchedule.map(c => c.id === classId ? { ...c, isActive: !c.isActive } : c)
            );
        } catch (error) {
            console.error("Error toggling class status:", error);
        }
    };

    const handleToggleAttendanceReminder = async (classId) => {
        try {
            const classRef = doc(db, "classSchedule", classId);
            const classDoc = await getDoc(classRef);
            const currentClass = classDoc.data();

            await updateDoc(classRef, {
                isAttendanceReminder: !currentClass.isAttendanceReminder
            });

            setClassSchedule(prevSchedule =>
                prevSchedule.map(c => c.id === classId ? { ...c, isAttendanceReminder: !c.isAttendanceReminder } : c)
            );
        } catch (error) {
            console.error("Error toggling:", error);
        }
    };

    const getPaymentStatus = (member) => {
        if (!member) return "ok";

        let expired = false;
        let warning = false;

        const now = new Date();

        // 1. End Date Checks
        if (member.membershipEndDate) {
            const endDate = member.membershipEndDate.toDate();
            const diffMs = endDate - now;
            const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

            if (endDate < now) {
                expired = true; // Already past date
            } else if (diffDays <= 7) {
                warning = true; // Final week
            }

        }

        // 1b. Stripe subscription current period end (if available)
        if (!expired && member.stripeCurrentPeriodEnd) {
            try {
                // stripeCurrentPeriodEnd is stored as a UNIX timestamp (seconds) by the sync
                const endDate = (typeof member.stripeCurrentPeriodEnd === 'number')
                    ? new Date(member.stripeCurrentPeriodEnd * 1000)
                    : (member.stripeCurrentPeriodEnd.toDate ? member.stripeCurrentPeriodEnd.toDate() : new Date(member.stripeCurrentPeriodEnd));
                const diffMs = endDate - now;
                const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

                if (endDate < now) {
                    expired = true;
                } else if (diffDays <= 7) {
                    warning = true;
                }
            } catch (e) {
                // ignore parse errors
            }
        }

        // 2. Classes Remaining Checks
        if (typeof member.classesRemaining === "number") {
            if (member.classesRemaining <= 0) {
                expired = true;
            } else if (member.classesRemaining <= 2) {
                warning = true;
            }

        }

        // 3. Stripe payment/subscription checks - only trust these while Stripe is actually linked;
        // otherwise fall back to the manually-set payment status so unlinking doesn't leave stale red status.
        if (member.stripeCustomerId) {
            if (member.stripeSubscriptionStatus && member.stripeSubscriptionStatus !== 'active') {
                expired = true;
            }

            if (member.stripePaymentStatus && member.stripePaymentStatus !== 'Paid') {
                expired = true;
            }
        } else if (member.manualPaymentStatus && member.manualPaymentStatus !== 'Paid' && member.manualPaymentStatus !== 'Not Set') {
            expired = true;
        }

        if (expired) return "expired";
        if (warning) return "warning";

        return "ok";
    };

    const dueMembers = filteredMembers.filter(
        (member) => getPaymentStatus(member) !== "ok"
    );


    const displayMembers = showPaymentDueOnly ? dueMembers : filteredMembers;


    const sortedMembers = [...displayMembers].sort((a, b) => {
        let aValue = a[sortField];
        let bValue = b[sortField];

        if (sortField === "membershipEndDate") {
            aValue = aValue ? aValue.toDate().getTime() : Infinity;
            bValue = bValue ? bValue.toDate().getTime() : Infinity;
        }
        if (sortField === "classesRemaining") {
            aValue = aValue === "Unlimited" ? Infinity : (parseInt(aValue, 10) || 0);
            bValue = bValue === "Unlimited" ? Infinity : (parseInt(bValue, 10) || 0);
        }

        if (typeof aValue === "string") aValue = aValue.toLowerCase();
        if (typeof bValue === "string") bValue = bValue.toLowerCase();

        if (aValue < bValue) return sortDirection === "asc" ? -1 : 1;
        if (aValue > bValue) return sortDirection === "asc" ? 1 : -1;
        return 0;
    });

    const totalPages = Math.ceil(sortedMembers.length / membersPerPage);
    const currentMembers = sortedMembers.slice(indexOfFirstMember, indexOfLastMember);


    const BackupButton = () => {
        return (
            <div className="backup-button-container">
                <button
                    className="backup-button"
                    onClick={handleBackupDatabase}
                    title="Download a backup of your database"
                >
                    <i className="fas fa-download"></i> Backup Database
                </button>
            </div>
        );
    };



    const handleBackupDatabase = async () => {
        try {
            setIsLoading(true);

            const collectionsToBackup = [
                "members",
                "coaches",
                "classSchedule",
                "bookings",
                "settings",
                "worklog",
                "membershipDetails",
                "secondaryAdmin",
                "admin",
                "agreements"
            ];

            const backupData = {};

            for (const collectionName of collectionsToBackup) {
                const collectionRef = collection(db, collectionName);
                const querySnapshot = await getDocs(collectionRef);

                backupData[collectionName] = {};

                querySnapshot.forEach((doc) => {
                    backupData[collectionName][doc.id] = doc.data();
                });
            }


            const jsonString = JSON.stringify(backupData, null, 2);

            const blob = new Blob([jsonString], { type: 'application/json' });

            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            const date = new Date();
            const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
            const formattedTime = `${date.getHours().toString().padStart(2, '0')}-${date.getMinutes().toString().padStart(2, '0')}`;
            link.download = `firebase-backup-${formattedDate}_${formattedTime}.json`;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(url);

            alert("Backup completed successfully!");
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error("Error backing up database:", error);
            alert("Failed to backup database. See console for details.");
            setIsLoading(false);
        }
    };

    const ClassRow = ({
        classItem,
        editingClass,
        setEditingClass,
        coaches,
        isSpecial,
        handleSaveClass,
        handleDeleteClass,
        isSecAdmin,
        handleToggleClass,
        handleToggleAttendanceReminder
    }) => {
        const isEditing = editingClass && editingClass.id === classItem.id;

        const [localClassName, setLocalClassName] = React.useState(classItem.className);
        const [localStartTime, setLocalStartTime] = React.useState(classItem.startTime);
        const [localEndTime, setLocalEndTime] = React.useState(classItem.endTime);
        const [localDays, setLocalDays] = React.useState(classItem.days || []);
        const [localSpecialClassDate, setLocalSpecialClassDate] = React.useState(classItem.specialClassDate || '');
        const [localCoaches, setLocalCoaches] = React.useState(classItem.coaches || []);
        const [localAvailableSpots, setLocalAvailableSpots] = React.useState(classItem.availableSpots);
        const [localIsSpecialClass, setLocalIsSpecialClass] = React.useState(classItem.isSpecialClass);
        const [localIsActive, setLocalIsActive] = React.useState(classItem.isActive);
        const [localIsAttendaceReminder, setLocalIsAttendanceReminder] = React.useState(classItem.isAttendanceReminder);
        const [localAllAttend, setLocalAllAttend] = React.useState(classItem.allAttend);

        React.useEffect(() => {
            if (isEditing) {
                setLocalClassName(classItem.className);
                setLocalStartTime(classItem.startTime);
                setLocalEndTime(classItem.endTime);
                setLocalDays(classItem.days || []);
                setLocalSpecialClassDate(classItem.specialClassDate || '');
                setLocalCoaches(classItem.coaches || []);
                setLocalAvailableSpots(classItem.availableSpots);
                setLocalIsSpecialClass(classItem.isSpecialClass);
                setLocalIsActive(classItem.isActive);
                setLocalIsAttendanceReminder(classItem.isAttendanceReminder);
                setLocalAllAttend(classItem.allAttend);
            }
        }, [isEditing, classItem]);

        const formatTimeDisplay = (time) => {
            if (!time) return '';
            // If it already contains AM/PM, return as-is
            if (/\bAM\b|\bPM\b/i.test(time)) return time;
            // Expecting HH:mm (24h) or H:mm
            const parts = time.split(':');
            if (parts.length < 2) return time;
            const hours = parseInt(parts[0], 10);
            const minutes = parseInt(parts[1], 10) || 0;
            const d = new Date();
            d.setHours(hours, minutes, 0, 0);
            return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
        };

        const save = () => {
            const updatedClass = {
                ...classItem,
                className: localClassName,
                startTime: localStartTime,
                endTime: localEndTime,
                days: localIsSpecialClass ? [] : localDays,
                specialClassDate: localIsSpecialClass ? localSpecialClassDate : null,
                coaches: localCoaches,
                availableSpots: localAvailableSpots,
                isSpecialClass: localIsSpecialClass,
                isActive: localIsActive,
                isAttendanceReminder: localIsAttendaceReminder,
                allAttend: localAllAttend,
            };
            handleSaveClass(classItem.id, updatedClass);
        };

        const toggleDay = (day) => {
            setLocalDays(prev => {
                if (prev.includes(day)) {
                    return prev.filter(d => d !== day);
                } else {
                    return [...prev, day];
                }
            });
        };



        return (
            <tr data-id={classItem.id}>
                <td className="border p-2">
                    {isEditing ? (
                        <input
                            type="text"
                            value={localClassName}
                            onChange={e => setLocalClassName(e.target.value)}
                            className="w-full p-1"
                        />
                    ) : (
                        classItem.className
                    )}
                </td>
                <td className="border p-2 min-w-[150px] whitespace-nowrap">
                    {isEditing ? (
                        <div className="flex flex-col sm:flex-row space-x-0 sm:space-x-1">
                            <div className="flex items-center gap-2 w-full sm:w-1/2 mb-1 sm:mb-0">
                                <DatePicker
                                    selected={timeStringToDate(localStartTime)}
                                    onChange={(date) => setLocalStartTime(dateToTimeString(date))}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={5}
                                    dateFormat="HH:mm"
                                    timeFormat="HH:mm"
                                    className="flex-1 p-1"
                                />
                            </div>
                            <div className="flex items-center gap-2 w-full sm:w-1/2">
                                <DatePicker
                                    selected={timeStringToDate(localEndTime)}
                                    onChange={(date) => setLocalEndTime(dateToTimeString(date))}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={5}
                                    dateFormat="HH:mm"
                                    timeFormat="HH:mm"
                                    className="flex-1 p-1"
                                />
                            </div>
                        </div>
                    ) : (
                        `${classItem.startTime} (${toAmPm(classItem.startTime)}) - ${classItem.endTime} (${toAmPm(classItem.endTime)})`
                    )}
                </td>
                <td className="border p-2">
                    {isEditing ? (
                        localIsSpecialClass ? (
                            <input
                                type="date"
                                value={localSpecialClassDate}
                                onChange={e => setLocalSpecialClassDate(e.target.value)}
                                className="p-1 border rounded w-full"
                            />
                        ) : (
                            <div className="flex flex-wrap space-x-2">
                                {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map(day => (
                                    <label key={day} className="flex items-center space-x-1">
                                        <input
                                            type="checkbox"
                                            checked={localDays.includes(day)}
                                            onChange={() => toggleDay(day)}
                                        />
                                        <span>{day}</span>
                                    </label>
                                ))}
                            </div>
                        )
                    ) : (
                        localIsSpecialClass
                            ? (classItem.specialClassDate ? new Date(classItem.specialClassDate).toLocaleDateString() : '')
                            : classItem.days.join(', ')
                    )}
                </td>
                <td className="border p-2">
                    {isEditing ? (
                        <CoachesDropdown
                            coaches={coaches}
                            selectedCoaches={localCoaches}
                            onChange={setLocalCoaches}
                        />
                    ) : (
                        (classItem.coaches || []).join(', ')
                    )}
                </td>
                <td className="border p-2">
                    {isEditing ? (
                        <input
                            type="number"
                            value={localAvailableSpots}
                            onChange={e => setLocalAvailableSpots(parseInt(e.target.value, 10))}
                            className="p-1 w-full"
                        />
                    ) : (
                        classItem.availableSpots
                    )}
                </td>
                <td className="border p-2">
                    {isEditing ? (
                        <select
                            value={localIsSpecialClass ? 'yes' : 'no'}
                            onChange={e => {
                                const isSpec = e.target.value === 'yes';
                                setLocalIsSpecialClass(isSpec);
                                if (isSpec) {
                                    setLocalDays([]);
                                } else {
                                    setLocalSpecialClassDate('');
                                }
                            }}
                            className="p-1 w-full"
                        >
                            <option value="no">No</option>
                            <option value="yes">Yes</option>
                        </select>
                    ) : (
                        localIsSpecialClass ? `Yes (${classItem.specialClassDate})` : 'No'
                    )}
                </td>
                <td className="border p-2">
                    {isEditing ? (
                        <>
                            <button
                                onClick={save}
                                disabled={isSecAdmin}
                                className="bg-green-500 text-white px-2 py-1 rounded mr-2 text-sm"
                            >
                                Save
                            </button>
                            <button
                                onClick={() => setEditingClass(null)}
                                disabled={isSecAdmin}
                                className="bg-gray-500 text-white px-2 py-1 rounded text-sm"
                            >
                                Cancel
                            </button>
                        </>
                    ) : (
                        <>
                            <button
                                onClick={() => setEditingClass(classItem)}
                                disabled={isSecAdmin}
                                className="bg-blue-500 text-white px-2 py-1 rounded mr-2 text-sm"
                            >
                                Edit
                            </button>
                            <button
                                onClick={() => handleDeleteClass(classItem.id)}
                                disabled={isSecAdmin}
                                className="bg-red-500 text-white px-2 py-1 rounded text-sm"
                            >
                                Delete
                            </button>
                        </>
                    )}
                </td>
                {/* Add your Voice Reminder and All Attend cells here as you do currently */}
                <td className="border p-2">
                    <label className="flex items-center cursor-pointer">
                        <div className="relative">
                            <input
                                type="checkbox"
                                className="sr-only"
                                disabled={isSecAdmin}
                                checked={classItem.isActive}
                                onChange={() => handleToggleClass(classItem.id)}
                            />
                            <div className={`block w-14 h-8 rounded-full ${classItem.isActive ? 'bg-green-400' : 'bg-gray-400'}`}></div>
                            <div className={`absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition-transform ${classItem.isActive ? 'transform translate-x-6' : ''}`}></div>
                        </div>
                        <span className="ml-3 text-sm font-medium text-gray-900">
                            {classItem.isActive ? 'Yes' : 'No'}
                        </span>
                    </label>
                </td>
                <td className="border p-2">
                    <label className="flex items-center cursor-pointer">
                        <div className="relative">
                            <input
                                type="checkbox"
                                className="sr-only"
                                disabled={isSecAdmin}
                                checked={classItem.isAttendanceReminder}
                                onChange={() => handleToggleAttendanceReminder(classItem.id)}
                            />
                            <div className={`block w-14 h-8 rounded-full ${classItem.isAttendanceReminder ? 'bg-green-400' : 'bg-gray-400'}`}></div>
                            <div className={`absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition-transform ${classItem.isAttendanceReminder ? 'transform translate-x-6' : ''}`}></div>
                        </div>
                        <span className="ml-3 text-sm font-medium text-gray-900">
                            {classItem.isAttendanceReminder ? 'Yes' : 'No'}
                        </span>
                    </label>
                </td>

                <td className="border p-2">
                    {isEditing ? (
                        <select
                            value={localAllAttend ? 'yes' : 'no'}
                            onChange={(e) => setLocalAllAttend(e.target.value === 'yes')}
                            className="p-1 w-full"
                        >
                            <option value="no">No</option>
                            <option value="yes">Yes</option>
                        </select>
                    ) : (
                        localAllAttend ? 'Yes' : 'No'
                    )}
                </td>
            </tr>
        );
    };

    const toggleMenu = (menuKey) => {
        setExpandedMenus(prev => ({
            ...prev,
            [menuKey]: !prev[menuKey]
        }));
    };

    const closeMobileSidebar = () => {
        setIsMobileSidebarOpen(false);
    };


    return (
        <div className={`flex h-screen overflow-hidden ${theme === 'dark' ? 'bg-gray-900' : 'bg-gray-100'}`}>
            {/* Mobile Backdrop Overlay */}
            {isMobileSidebarOpen && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
                    onClick={closeMobileSidebar}
                />
            )}

            {/* Left Sidebar */}
            <div className={`
                ${isSidebarCollapsed ? 'w-16' : 'w-56 sm:w-64'} 
                bg-gradient-to-b from-blue-600 to-blue-800 text-white flex flex-col transition-all duration-300 shadow-2xl
                fixed lg:relative inset-y-0 left-0 z-50
                transform lg:transform-none
                ${isMobileSidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
            `}>
                {/* Admin Profile Section */}
                <div className={`p-4 sm:p-6 border-b border-blue-500 ${isSidebarCollapsed ? 'text-center' : ''}`}>
                    {!isSidebarCollapsed && (
                        <>
                            <div className="flex items-center justify-center mb-3 sm:mb-4">
                                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-white rounded-full flex items-center justify-center text-blue-600 font-bold text-xl shadow-lg">
                                    {adminName.charAt(0).toUpperCase()}
                                </div>
                            </div>
                            <h2 className="text-base font-bold text-center truncate">{adminName}</h2>
                            <p className="text-blue-200 text-sm text-center truncate mt-1">{adminEmail}</p>
                        </>
                    )}
                    {isSidebarCollapsed && (
                        <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-blue-600 font-bold mx-auto">
                            {adminName.charAt(0).toUpperCase()}
                        </div>
                    )}
                </div>

                {/* Navigation Menu */}
                <nav className="flex-1 overflow-y-auto py-3 sm:py-4 px-2">
                    {/* Members Section */}
                    <div className="mb-1">
                        <button
                            onClick={() => !isSidebarCollapsed && toggleMenu('members')}
                            className={`w-full flex items-center justify-between px-3 py-2.5 rounded-lg transition-all ${
                                tab === 'members' || tab === 'member_report' || tab === 'bookings' || tab === 'archive' || tab === 'paymentStatus'
                                    ? 'bg-white/15 text-white'
                                    : 'text-blue-100 hover:bg-white/10 hover:text-white'
                            }`}
                            title={isSidebarCollapsed ? "Members" : ""}
                        >
                            <div className="flex items-center gap-2.5">
                                <FaUsers className="text-base flex-shrink-0" />
                                {!isSidebarCollapsed && <span className="font-bold text-xs uppercase tracking-wider">Members</span>}
                            </div>
                            {!isSidebarCollapsed && (
                                expandedMenus.members
                                    ? <FaChevronDown className="text-xs opacity-60" />
                                    : <FaChevronRight className="text-xs opacity-60" />
                            )}
                        </button>
                        {expandedMenus.members && !isSidebarCollapsed && (
                            <div className="mt-1 ml-3 pl-3 border-l-2 border-blue-400/40 space-y-0.5">
                                <button
                                    onClick={() => { setTab('members'); closeMobileSidebar(); }}
                                    className={`w-full text-left px-3 py-2 rounded-md transition-all flex items-center gap-2 ${
                                        tab === 'members'
                                            ? 'bg-white text-blue-700 font-semibold shadow-sm'
                                            : 'text-blue-100 hover:bg-white/10 hover:text-white'
                                    }`}
                                >
                                    <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${tab === 'members' ? 'bg-blue-600' : 'bg-blue-300/60'}`} />
                                    <span className="text-xs">Members Details</span>
                                </button>
                                <button
                                    onClick={() => { setTab('member_report'); closeMobileSidebar(); }}
                                    className={`w-full text-left px-3 py-2 rounded-md transition-all flex items-center gap-2 ${
                                        tab === 'member_report'
                                            ? 'bg-white text-blue-700 font-semibold shadow-sm'
                                            : 'text-blue-100 hover:bg-white/10 hover:text-white'
                                    }`}
                                >
                                    <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${tab === 'member_report' ? 'bg-blue-600' : 'bg-blue-300/60'}`} />
                                    <span className="text-xs">Generate Report</span>
                                </button>
                                <button
                                    onClick={() => { setTab('bookings'); closeMobileSidebar(); }}
                                    className={`w-full text-left px-3 py-2 rounded-md transition-all flex items-center gap-2 ${
                                        tab === 'bookings'
                                            ? 'bg-white text-blue-700 font-semibold shadow-sm'
                                            : 'text-blue-100 hover:bg-white/10 hover:text-white'
                                    }`}
                                >
                                    <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${tab === 'bookings' ? 'bg-blue-600' : 'bg-blue-300/60'}`} />
                                    <span className="text-xs">Booking Details</span>
                                </button>
                                <button
                                    onClick={() => { setTab('archive'); closeMobileSidebar(); }}
                                    className={`w-full text-left px-3 py-2 rounded-md transition-all flex items-center gap-2 ${
                                        tab === 'archive'
                                            ? 'bg-white text-blue-700 font-semibold shadow-sm'
                                            : 'text-blue-100 hover:bg-white/10 hover:text-white'
                                    }`}
                                >
                                    <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${tab === 'archive' ? 'bg-blue-600' : 'bg-blue-300/60'}`} />
                                    <span className="text-xs">Archived Members</span>
                                </button>
                                <button
                                    onClick={() => { setTab('paymentStatus'); closeMobileSidebar(); }}
                                    className={`w-full text-left px-3 py-2 rounded-md transition-all flex items-center gap-2 ${
                                        tab === 'paymentStatus'
                                            ? 'bg-white text-blue-700 font-semibold shadow-sm'
                                            : 'text-blue-100 hover:bg-white/10 hover:text-white'
                                    }`}
                                >
                                    <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${tab === 'paymentStatus' ? 'bg-blue-600' : 'bg-blue-300/60'}`} />
                                    <span className="text-xs">Payment Status</span>
                                </button>
                            </div>
                        )}
                    </div>

                    {/* Instructors Section */}
                    {!isSecAdmin && (
                        <div className="mb-1">
                            <button
                                onClick={() => !isSidebarCollapsed && toggleMenu('instructors')}
                                className={`w-full flex items-center justify-between px-3 py-2.5 rounded-lg transition-all ${
                                    tab === 'coaches' || tab === 'staff_report' || tab === 'archivedCoaches'
                                        ? 'bg-white/15 text-white'
                                        : 'text-blue-100 hover:bg-white/10 hover:text-white'
                                }`}
                                title={isSidebarCollapsed ? "Instructors" : ""}
                            >
                                <div className="flex items-center gap-2.5">
                                    <FaUserTie className="text-base flex-shrink-0" />
                                    {!isSidebarCollapsed && <span className="font-bold text-xs uppercase tracking-wider">Instructors</span>}
                                </div>
                                {!isSidebarCollapsed && (
                                    expandedMenus.instructors
                                        ? <FaChevronDown className="text-xs opacity-60" />
                                        : <FaChevronRight className="text-xs opacity-60" />
                                )}
                            </button>
                            {expandedMenus.instructors && !isSidebarCollapsed && (
                                <div className="mt-1 ml-3 pl-3 border-l-2 border-blue-400/40 space-y-0.5">
                                    <button
                                        onClick={() => { setTab('coaches'); closeMobileSidebar(); }}
                                        className={`w-full text-left px-3 py-2 rounded-md transition-all flex items-center gap-2 ${
                                            tab === 'coaches'
                                                ? 'bg-white text-blue-700 font-semibold shadow-sm'
                                                : 'text-blue-100 hover:bg-white/10 hover:text-white'
                                        }`}
                                    >
                                        <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${tab === 'coaches' ? 'bg-blue-600' : 'bg-blue-300/60'}`} />
                                        <span className="text-xs">Instructor Details</span>
                                    </button>
                                    <button
                                        onClick={() => { setTab('staff_report'); closeMobileSidebar(); }}
                                        className={`w-full text-left px-3 py-2 rounded-md transition-all flex items-center gap-2 ${
                                            tab === 'staff_report'
                                                ? 'bg-white text-blue-700 font-semibold shadow-sm'
                                                : 'text-blue-100 hover:bg-white/10 hover:text-white'
                                        }`}
                                    >
                                        <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${tab === 'staff_report' ? 'bg-blue-600' : 'bg-blue-300/60'}`} />
                                        <span className="text-xs">Generate Report</span>
                                    </button>
                                    <button
                                        onClick={() => { setTab('archivedCoaches'); closeMobileSidebar(); }}
                                        className={`w-full text-left px-3 py-2 rounded-md transition-all flex items-center gap-2 ${
                                            tab === 'archivedCoaches'
                                                ? 'bg-white text-blue-700 font-semibold shadow-sm'
                                                : 'text-blue-100 hover:bg-white/10 hover:text-white'
                                        }`}
                                    >
                                        <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${tab === 'archivedCoaches' ? 'bg-blue-600' : 'bg-blue-300/60'}`} />
                                        <span className="text-xs">Archived Instructors</span>
                                    </button>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Separator */}
                    {!isSidebarCollapsed && (
                        <div className="my-2 mx-2 border-t border-blue-500/50"></div>
                    )}

                    {/* Schedule Classes */}
                    {!isSecAdmin && (
                        <button
                            onClick={() => { setTab('schedule'); closeMobileSidebar(); }}
                            className={`w-full flex items-center gap-2.5 px-3 py-2.5 rounded-lg transition-all mb-1 ${
                                tab === 'schedule'
                                    ? 'bg-white text-blue-700 font-semibold shadow-sm'
                                    : 'text-blue-100 hover:bg-white/10 hover:text-white'
                            }`}
                            title={isSidebarCollapsed ? "Schedule Classes" : ""}
                        >
                            <FaCalendarAlt className={`text-base flex-shrink-0 ${tab === 'schedule' ? 'text-blue-600' : ''}`} />
                            {!isSidebarCollapsed && <span className="font-bold text-xs uppercase tracking-wider">Schedule Classes</span>}
                        </button>
                    )}

                    {/* Membership */}
                    {!isSecAdmin && (
                        <button
                            onClick={() => { setTab('membershipDetails'); closeMobileSidebar(); }}
                            className={`w-full flex items-center gap-2.5 px-3 py-2.5 rounded-lg transition-all mb-1 ${
                                tab === 'membershipDetails'
                                    ? 'bg-white text-blue-700 font-semibold shadow-sm'
                                    : 'text-blue-100 hover:bg-white/10 hover:text-white'
                            }`}
                            title={isSidebarCollapsed ? "Set Membership" : ""}
                        >
                            <FaFileAlt className={`text-base flex-shrink-0 ${tab === 'membershipDetails' ? 'text-blue-600' : ''}`} />
                            {!isSidebarCollapsed && <span className="font-bold text-xs uppercase tracking-wider">Set Membership</span>}
                        </button>
                    )}

                    {/* Assistant Admin */}
                    {!isSecAdmin && (
                        <button
                            onClick={() => { setTab('secAdmin'); closeMobileSidebar(); }}
                            className={`w-full flex items-center gap-2.5 px-3 py-2.5 rounded-lg transition-all mb-1 ${
                                tab === 'secAdmin'
                                    ? 'bg-white text-blue-700 font-semibold shadow-sm'
                                    : 'text-blue-100 hover:bg-white/10 hover:text-white'
                            }`}
                            title={isSidebarCollapsed ? "Assistant Admin" : ""}
                        >
                            <FaUserShield className={`text-base flex-shrink-0 ${tab === 'secAdmin' ? 'text-blue-600' : ''}`} />
                            {!isSidebarCollapsed && <span className="font-bold text-xs uppercase tracking-wider">Assistant Admin</span>}
                        </button>
                    )}

                    {/* Class Performance Report */}
                    {!isSecAdmin && (
                        <button
                            onClick={() => { setTab('classPerformanceReport'); closeMobileSidebar(); }}
                            className={`w-full flex items-center gap-2.5 px-3 py-2.5 rounded-lg transition-all mb-1 ${
                                tab === 'classPerformanceReport'
                                    ? 'bg-white text-blue-700 font-semibold shadow-sm'
                                    : 'text-blue-100 hover:bg-white/10 hover:text-white'
                            }`}
                            title={isSidebarCollapsed ? "Class Performance" : ""}
                        >
                            <FaChartBar className={`text-base flex-shrink-0 ${tab === 'classPerformanceReport' ? 'text-blue-600' : ''}`} />
                            {!isSidebarCollapsed && <span className="font-bold text-xs uppercase tracking-wider">Class Performance</span>}
                        </button>
                    )}

                    {/* Separator before Settings */}
                    {!isSecAdmin && !isSidebarCollapsed && (
                        <div className="my-2 mx-2 border-t border-blue-500/50"></div>
                    )}

                    {/* Settings Section */}
                    {!isSecAdmin && (
                        <div className="mb-1">
                            <button
                                onClick={() => !isSidebarCollapsed && toggleMenu('settings')}
                                className={`w-full flex items-center justify-between px-3 py-2.5 rounded-lg transition-all ${
                                    tab === 'logoSettings' || tab === 'bookingSettings' || tab === 'agreement' || tab === 'categories'
                                        ? 'bg-white/15 text-white'
                                        : 'text-blue-100 hover:bg-white/10 hover:text-white'
                                }`}
                                title={isSidebarCollapsed ? "General Settings" : ""}
                            >
                                <div className="flex items-center gap-2.5">
                                    <FaCog className="text-base flex-shrink-0" />
                                    {!isSidebarCollapsed && <span className="font-bold text-xs uppercase tracking-wider">General Settings</span>}
                                </div>
                                {!isSidebarCollapsed && (
                                    expandedMenus.settings
                                        ? <FaChevronDown className="text-xs opacity-60" />
                                        : <FaChevronRight className="text-xs opacity-60" />
                                )}
                            </button>
                            {expandedMenus.settings && !isSidebarCollapsed && (
                                <div className="mt-1 ml-3 pl-3 border-l-2 border-blue-400/40 space-y-0.5">
                                    <button
                                        onClick={() => { setTab('logoSettings'); closeMobileSidebar(); }}
                                        className={`w-full text-left px-3 py-2 rounded-md transition-all flex items-center gap-2 ${
                                            tab === 'logoSettings'
                                                ? 'bg-white text-blue-700 font-semibold shadow-sm'
                                                : 'text-blue-100 hover:bg-white/10 hover:text-white'
                                        }`}
                                    >
                                        <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${tab === 'logoSettings' ? 'bg-blue-600' : 'bg-blue-300/60'}`} />
                                        <span className="text-xs">Logo</span>
                                    </button>
                                    <button
                                        onClick={() => { setTab('bookingSettings'); closeMobileSidebar(); }}
                                        className={`w-full text-left px-3 py-2 rounded-md transition-all flex items-center gap-2 ${
                                            tab === 'bookingSettings'
                                                ? 'bg-white text-blue-700 font-semibold shadow-sm'
                                                : 'text-blue-100 hover:bg-white/10 hover:text-white'
                                        }`}
                                    >
                                        <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${tab === 'bookingSettings' ? 'bg-blue-600' : 'bg-blue-300/60'}`} />
                                        <span className="text-xs">Class Booking</span>
                                    </button>
                                    <button
                                        onClick={() => { setTab('agreement'); closeMobileSidebar(); }}
                                        className={`w-full text-left px-3 py-2 rounded-md transition-all flex items-center gap-2 ${
                                            tab === 'agreement'
                                                ? 'bg-white text-blue-700 font-semibold shadow-sm'
                                                : 'text-blue-100 hover:bg-white/10 hover:text-white'
                                        }`}
                                    >
                                        <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${tab === 'agreement' ? 'bg-blue-600' : 'bg-blue-300/60'}`} />
                                        <span className="text-xs">Agreement</span>
                                    </button>
                                    <button
                                        onClick={() => { setTab('categories'); closeMobileSidebar(); fetchCategories(); }}
                                        className={`w-full text-left px-3 py-2 rounded-md transition-all flex items-center gap-2 ${
                                            tab === 'categories'
                                                ? 'bg-white text-blue-700 font-semibold shadow-sm'
                                                : 'text-blue-100 hover:bg-white/10 hover:text-white'
                                        }`}
                                    >
                                        <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${tab === 'categories' ? 'bg-blue-600' : 'bg-blue-300/60'}`} />
                                        <span className="text-xs">Categories</span>
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                </nav>

                {/* Sign Out Button */}
                <div className="p-3 sm:p-4 border-t border-blue-500">
                    <button
                        onClick={handleSignOut}
                        className={`w-full flex items-center gap-2 sm:gap-3 px-3 sm:px-4 py-2.5 sm:py-3 bg-blue-900 hover:bg-blue-950 rounded-lg transition-all font-semibold ${
                            isSidebarCollapsed ? 'justify-center' : ''
                        }`}
                        title={isSidebarCollapsed ? "Sign Out" : ""}
                    >
                        <FaSignOutAlt className="text-base" />
                        {!isSidebarCollapsed && <span className="text-sm">Sign Out</span>}
                    </button>
                </div>
            </div>

            {/* Main Content Area */}
            <div className="flex-1 flex flex-col overflow-hidden w-full ml-0 lg:ml-0">
                {/* Top Header Bar */}
                <div className={`shadow-md px-3 sm:px-4 lg:px-6 py-3 sm:py-4 flex items-center justify-between ${
                    theme === 'dark' ? 'bg-gray-800 text-white' : 'bg-white'
                }`}>
                    <div className="flex items-center gap-2 sm:gap-3 lg:gap-4 flex-1 min-w-0">
                        <button
                            onClick={() => {
                                if (window.innerWidth < 1024) {
                                    setIsMobileSidebarOpen(!isMobileSidebarOpen);
                                } else {
                                    setIsSidebarCollapsed(!isSidebarCollapsed);
                                }
                            }}
                            className={`transition-colors flex-shrink-0 ${
                                theme === 'dark' ? 'text-gray-300 hover:text-blue-400' : 'text-gray-600 hover:text-blue-600'
                            }`}
                        >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        </button>
                        <div>
                            <h1 className={`text-lg sm:text-xl font-bold truncate ${
                                theme === 'dark' ? 'text-white' : 'text-gray-800'
                            }`}>
                                Welcome, {adminName}!
                            </h1>
                            <p className={`text-xs sm:text-sm ${
                                theme === 'dark' ? 'text-gray-400' : 'text-gray-600'
                            }`}>
                                {tab === 'members' && 'Members Details'}
                                {tab === 'member_report' && 'Member Report'}
                                {tab === 'bookings' && 'Booking Details'}
                                {tab === 'coaches' && 'Instructor Details'}
                                {tab === 'staff_report' && 'Instructor Report'}
                                {tab === 'schedule' && 'Schedule Classes'}
                                {tab === 'membershipDetails' && 'Set Membership'}
                                {tab === 'logoSettings' && 'Logo Configuration'}
                                {tab === 'bookingSettings' && 'Class Booking Configuration'}
                                {tab === 'stripeExport' && 'Stripe Data Export'}
                                {tab === 'paymentStatus' && 'Member Payment Status'}
                                {tab === 'agreement' && 'Agreement Management'}
                                {tab === 'archive' && 'Archived Members'}
                                {tab === 'archivedCoaches' && 'Archived Instructors'}
                                {tab === 'secAdmin' && 'Assistant Admin'}
                                {tab === 'categories' && 'Manage Categories'}
                                {tab === 'classPerformanceReport' && 'Class Performance Report'}
                            </p>
                        </div>
                    </div>
                    <div className="flex gap-1.5 sm:gap-2 lg:gap-3 items-center flex-shrink-0">
                        {/* Theme Toggle Button */}
                        <div className="flex items-center space-x-1 sm:space-x-2 bg-white/10 px-2 sm:px-3 py-1.5 sm:py-2 rounded-lg">
                            <span className={`hidden xs:inline text-xs sm:text-sm font-medium ${
                                theme === 'dark' ? 'text-gray-300' : 'text-gray-600'
                            }`}>Light</span>
                            <button
                                onClick={() => setTheme(prev => prev === 'light' ? 'dark' : 'light')}
                                aria-label="Toggle theme"
                                className="transition-all duration-200 focus:outline-none"
                                title={`Switch to ${theme === 'light' ? 'dark' : 'light'} theme`}
                            >
                                <FaToggleOn 
                                    className={`text-2xl sm:text-3xl transition-all duration-200 ${
                                        theme === 'dark' ? 'text-blue-500' : 'text-gray-600'
                                    }`}
                                    style={{ transform: theme === 'dark' ? 'scaleX(1)' : 'scaleX(-1)' }}
                                />
                            </button>
                            <span className={`hidden xs:inline text-xs sm:text-sm font-medium ${
                                theme === 'dark' ? 'text-gray-300' : 'text-gray-600'
                            }`}>Dark</span>
                        </div>
                        {/* User Profile Dropdown */}
                        <div className="relative">
                            <button
                                onClick={() => setShowProfileDropdown(!showProfileDropdown)}
                                className={`flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-2 rounded-lg transition-all ${
                                    theme === 'dark' ? 'hover:bg-gray-700' : 'hover:bg-gray-100'
                                }`}
                            >
                                <div className="w-7 h-7 sm:w-8 sm:h-8 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-xs sm:text-sm">
                                    {adminName.charAt(0).toUpperCase()}
                                </div>
                                <FaChevronDown className="text-sm" />
                            </button>
                            {showProfileDropdown && (
                                <div className={`absolute right-0 mt-2 w-48 rounded-lg shadow-lg z-50 overflow-hidden ${
                                    theme === 'dark' ? 'bg-gray-800 border border-gray-700' : 'bg-white border border-gray-200'
                                }`}>
                                    <div className={`px-4 py-3 border-b ${
                                        theme === 'dark' ? 'border-gray-700' : 'border-gray-200'
                                    }`}>
                                        <p className={`font-semibold truncate ${
                                            theme === 'dark' ? 'text-white' : 'text-gray-800'
                                        }`}>{adminName}</p>
                                        <p className={`text-sm truncate ${
                                            theme === 'dark' ? 'text-gray-400' : 'text-gray-600'
                                        }`}>{adminEmail}</p>
                                    </div>
                                    <button
                                        onClick={() => {
                                            handleSignOut();
                                            setShowProfileDropdown(false);
                                        }}
                                        className={`w-full px-4 py-3 text-left flex items-center gap-2 transition-colors ${
                                            theme === 'dark' ? 'hover:bg-gray-700 text-gray-300' : 'hover:bg-gray-100 text-gray-700'
                                        }`}
                                    >
                                        <FaSignOutAlt />
                                        <span>Sign Out</span>
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Content Area */}
                <div className={`flex-1 overflow-y-auto ${
                    theme === 'dark' ? 'bg-gray-900' : 'bg-gray-50'
                }`}>

            {tab === "members" && (
                <LoadingOverlay isLoading={isLoading || !membersLoaded}>
                    <div className="flex flex-col p-3 sm:p-4 lg:p-6">
                        {/* Backup and Payment Due Buttons */}
                        <div className="flex flex-wrap gap-2 mb-4">
                            {!isSecAdmin && (
                                <button
                                    onClick={handleBackupDatabase}
                                    className="px-3 sm:px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-all shadow-md flex items-center gap-2 text-sm font-medium"
                                    title="Backup Database"
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
                                    </svg>
                                    <span>Backup</span>
                                </button>
                            )}
                            <button
                                onClick={() => { setShowPaymentDueOnly(!showPaymentDueOnly); setCurrentPage(1); }}
                                className={`px-3 sm:px-4 py-2 rounded-lg transition-all shadow-md text-sm font-medium whitespace-nowrap ${
                                    showPaymentDueOnly ? 'bg-yellow-600 text-white' : 'bg-yellow-400 text-black'
                                }`}
                            >
                                {showPaymentDueOnly ? 'Showing Due' : 'Payment Due'}
                            </button>
                        </div>
                        {/* Search and Filter */}
                        <div className="flex flex-col sm:flex-row gap-3 mb-4">
                            <input
                                type="text"
                                placeholder="Search members..."
                                value={searchTerm}
                                onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                                className={`flex-1 p-3 border-2 rounded-md shadow-sm focus:outline-none focus:ring-2 text-sm ${
                                    theme === 'dark' ? 'bg-gray-700 text-white border-gray-600 focus:ring-blue-500 placeholder-gray-400' : 'bg-white text-gray-900 border-blue-500 focus:ring-blue-300'
                                }`}
                            />
                            <select
                                value={statusFilter}
                                onChange={(e) => {
                                    setStatusFilter(e.target.value);
                                    setCurrentPage(1);
                                }}
                                className={`p-3 border-2 rounded-md text-sm sm:w-auto w-full ${
                                    theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : 'bg-white text-gray-900 border-blue-500'
                                }`}
                            >
                                <option value="All">All Statuses</option>
                                {[...new Set(members.map(member => member.status).filter(Boolean))].map(status => (
                                    <option key={status} value={status}>{status}</option>
                                ))}
                            </select>
                        </div>
                        {/* Status Legend */}
                        <div className={`flex flex-col sm:flex-row sm:justify-center sm:items-center gap-3 sm:gap-4 mb-4 ${
                            theme === 'dark' ? 'text-gray-300' : 'text-gray-900'
                        }`}>
                            <div className="flex items-center gap-2">
                                <div className="w-4 h-4 bg-red-300 border border-gray-400 flex-shrink-0"></div>
                                <span className="text-xs sm:text-sm">Expired</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <div className="w-4 h-4 bg-yellow-200 border border-gray-400 flex-shrink-0"></div>
                                <span className="text-xs sm:text-sm">Expiring Soon (last week or ≤2 classes left)</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <div className="w-4 h-4 bg-gray-200 border border-gray-400 flex-shrink-0"></div>
                                <span className="text-xs sm:text-sm">Active</span>
                            </div>
                        </div>
                        {/* Table Controls */}
                        <div className="mb-4">
                            <TableControls
                                sortField={sortField}
                                sortDirection={sortDirection}
                                setSortField={setSortField}
                                setSortDirection={setSortDirection}
                                membersPerPage={membersPerPage}
                                setMembersPerPage={setMembersPerPage}
                                totalItems={displayMembers.length}
                                theme={theme}
                            />
                        </div>

                        <div className="overflow-x-auto">
                            <table className="w-full text-sm text-center">
                                <thead className="text-sm text-white uppercase bg-blue-600">
                                    <tr>

                                        <th scope="col" className="px-4 py-3 sticky left-0 bg-blue-600 z-10">Name</th>
                                        <th scope="col" className="px-4 py-3">Email</th>
                                        <th scope="col" className="px-4 py-3">Period Attended</th>
                                        <th scope="col" className="px-4 py-3">Classes Remaining</th>
                                        <th scope="col" className="px-4 py-3">Membership Status</th>
                                        <th scope="col" className="px-4 py-3">Start Date</th>
                                        <th scope="col" className="px-4 py-3">End Date</th>
                                        <th scope="col" className="px-4 py-3 whitespace-nowrap min-w-[180px]">Select Classes to Attend</th>
                                        <th scope="col" className="px-4 py-3">Category</th>
                                        <th scope="col" className="px-4 py-3">Last Attendance</th>
                                        <th scope="col" className="px-4 py-3">Booked Classes</th>
                                        <th scope="col" className="px-4 py-3">Barcode</th>
                                        <th scope="col" className="px-4 py-3">Agreement</th>
                                        <th scope="col" className="px-4 py-3">Actions</th>
                                        <th scope="col" className="px-4 py-3">Archive Member</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {currentMembers.map((member, index) => {
                                        return (

                                            <tr key={member.id} className={`border-b ${
                                                getPaymentStatus(member) === "expired" ? (theme === 'dark' ? 'bg-red-900' : 'bg-red-200') : ""
                                            } ${
                                                getPaymentStatus(member) === "warning" ? (theme === 'dark' ? 'bg-yellow-900' : 'bg-yellow-200') : ""
                                            }`}>
                                                <td className={`px-4 py-3 sticky left-0 z-10 ${
                                                    theme === 'dark' ? 'text-gray-200' : 'text-gray-900'
                                                } ${
                                                    getPaymentStatus(member) === "expired" ? (theme === 'dark' ? 'bg-red-900' : 'bg-red-200') : 
                                                    getPaymentStatus(member) === "warning" ? (theme === 'dark' ? 'bg-yellow-900' : 'bg-yellow-200') : 
                                                    (theme === 'dark' ? 'bg-gray-800' : 'bg-white')
                                                }`}>{member.name} {member?.lastName ? member.lastName : ""}</td>
                                                <td className={`px-4 py-3 ${
                                                    theme === 'dark' ? 'text-gray-200' : 'text-gray-900'
                                                }`}>{member.email}</td>

                                                <td className={`px-4 py-3 ${
                                                    theme === 'dark' ? 'text-gray-200' : 'text-gray-900'
                                                }`}>{member.weeklyClassesAttended || 0}</td>
                                                <td className={`px-4 py-3 ${
                                                    theme === 'dark' ? 'text-gray-200' : 'text-gray-900'
                                                }`}>
                                                    {editingMemberId === member.id ? (

                                                        <input
                                                            type="text"
                                                            value={newClassesRemaining}
                                                            onChange={(e) => setNewClassesRemaining(e.target.value)}
                                                            onBlur={() => {
                                                                const val = newClassesRemaining.trim();
                                                                if (
                                                                    val !== "" &&
                                                                    val.toLowerCase() !== "unlimited" &&
                                                                    !/^\d+$/.test(val)
                                                                ) {
                                                                    showModal('Please enter a numeric value or "Unlimited"');
                                                                    setNewClassesRemaining("");
                                                                }
                                                            }}
                                                            className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                                                                theme === 'dark' ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-900'
                                                            }`}
                                                        />

                                                    ) : (
                                                        member.classesRemaining === 'Unlimited' ? 'Unlimited' : (member.classesRemaining || 0)
                                                    )}
                                                </td>

                                                <td className={`px-4 py-3 ${
                                                    theme === 'dark' ? 'text-gray-200' : 'text-gray-900'
                                                }`}>
                                                    {editingMemberId === member.id ? (
                                                        <select
                                                            value={newStatus}
                                                            onChange={(e) => { setNewStatus(e.target.value); setNewClassesRemaining(""); }}
                                                            className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                                                                theme === 'dark' ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-900'
                                                            }`}
                                                        >
                                                            <option value="">Select Status</option>
                                                            {membershipOptions.map(option => (
                                                                <option key={option.id} value={option.name}>{option.name}</option>
                                                            ))}
                                                        </select>
                                                    ) : (
                                                        member.status || "Not Set"
                                                    )}
                                                </td>
                                                <td className={`px-4 py-3 ${
                                                    theme === 'dark' ? 'text-gray-200' : 'text-gray-900'
                                                }`}>
                                                    {editingMemberId === member.id ? (
                                                        <input
                                                            type="date"
                                                            value={membershipStartDate}
                                                            onChange={(e) => setMembershipStartDate(e.target.value)}
                                                            className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                                                                theme === 'dark' ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-900'
                                                            }`}
                                                        />
                                                    ) : (
                                                        member.membershipStartDate?.toDate().toLocaleDateString() || "Not Set"
                                                    )}
                                                </td>

                                                <td className={`px-4 py-3 ${
                                                    theme === 'dark' ? 'text-gray-200' : 'text-gray-900'
                                                }`}>
                                                    {editingMemberId === member.id ? (
                                                        <input
                                                            type="date"
                                                            value={manualEndDate}
                                                            onChange={(e) => setManualEndDate(e.target.value)}
                                                            className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                                                                theme === 'dark' ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-900'
                                                            }`}
                                                        //disabled={!newStatus.toLowerCase().includes("free")}
                                                        />
                                                    ) : (
                                                        member.membershipEndDate ? member.membershipEndDate.toDate().toLocaleDateString() : "Unlimited"
                                                    )}
                                                </td>

                                                <td className={`px-4 py-3 whitespace-nowrap relative overflow-visible ${
                                                    theme === 'dark' ? 'text-gray-200' : 'text-gray-900'
                                                }`}>
                                                    {editingMemberId === member.id ? (
                                                        <ClassesDropdown
                                                            selectedIds={selectedClassesIds}
                                                            // onChange={setSelectedClassesIds}
                                                            onChange={async (newSelectedIds) => {
                                                                setSelectedClassesIds(newSelectedIds);
                                                                if (editingMemberId) {
                                                                    await handleMemberClassChange(editingMemberId, newSelectedIds);
                                                                }
                                                            }}
                                                            isSecAdmin={false}
                                                            theme={theme}
                                                        />
                                                    ) : (
                                                        (() => {
                                                            // Get the latest member data to ensure we show current classes
                                                            const currentMember = members.find(m => m.id === member.id);
                                                            const classNames = getClassNamesFromIds(currentMember?.eligibleClasses || member.eligibleClasses);
                                                            if (classNames.length === 0) return "No classes";
                                                            return (
                                                                <span
                                                                    title={classNames.join(', ')}
                                                                    className="block truncate"
                                                                >
                                                                    {classNames[0]}
                                                                    {classNames.length > 1 ? "…" : ""}
                                                                </span>
                                                            );
                                                        })()
                                                    )}
                                                </td>

                                                <td className="px-4 py-3 min-w-[150px]">
                                                    <Select
                                                        value={member.category || undefined}
                                                        onChange={val => handleUpdateMemberCategory(member.id, val ?? "")}
                                                        style={{ width: '100%' }}
                                                        placeholder="No Category"
                                                        allowClear
                                                        options={categories.map(cat => ({ label: cat.name, value: cat.name }))}
                                                        size="small"
                                                    />
                                                </td>

                                                <td className={`px-4 py-3 ${
                                                    theme === 'dark' ? 'text-gray-200' : 'text-gray-900'
                                                }`}>
                                                    {member.lastGymAttendance?.toDate().toLocaleDateString() || "Not attended yet"}
                                                </td>

                                                <td className={`px-4 py-3 max-w-xs truncate ${
                                                    theme === 'dark' ? 'text-gray-200' : 'text-gray-900'
                                                }`}>
                                                    {memberBookings[member.id] ? (() => {
                                                        const upcomingBookings = memberBookings[member.id]
                                                            .filter(booking => {
                                                                const bookingDate = new Date(booking.date);
                                                                const today = new Date();
                                                                today.setHours(0, 0, 0, 0);
                                                                return bookingDate >= today;
                                                            });

                                                        if (upcomingBookings.length === 0) return "No bookings";

                                                        // Prepare tooltip text
                                                        const tooltip = upcomingBookings
                                                            .map(
                                                                booking =>
                                                                    `${booking.className} - ${booking.date} (${booking.time})`
                                                            )
                                                            .join('\n');


                                                        return (
                                                            <span className="block truncate" title={tooltip}>
                                                                {`${upcomingBookings[0].className} - ${upcomingBookings[0].date} (${upcomingBookings[0].time})`}
                                                                {upcomingBookings.length > 1 ? "…" : ""}
                                                            </span>
                                                        );
                                                    })() : "No bookings"}
                                                </td>

                                                <td className="px-4 py-3">
                                                    {assigningBarcodeId === member.id ? (
                                                        <div className="flex items-center space-x-2">
                                                            <input
                                                                ref={barcodeInputRef}
                                                                type="text"
                                                                value={scannedBarcode}
                                                                onChange={handleBarcodeInput}
                                                                placeholder="Scan or enter barcode"
                                                                className="border px-2 py-1 rounded w-32"
                                                                autoFocus
                                                            />
                                                            <button
                                                                className="text-green-600 text-xl"
                                                                title="Save"
                                                                onClick={() => handleSaveBarcode(member.id)}
                                                            >
                                                                <FaCheck />
                                                            </button>
                                                            <button
                                                                className="text-red-600 text-xl"
                                                                title="Cancel"
                                                                onClick={handleCancelBarcode}
                                                            >
                                                                <FaTimes />
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <div className="flex items-center space-x-2">
                                                            {member.barcode ? (
                                                                <>
                                                                    <span className="text-green-600 font-semibold">{member.barcode}</span>
                                                                    <button
                                                                        onClick={() => handleStartAssignBarcode(member.id, member.barcode)}
                                                                        title="Edit Barcode"
                                                                    >
                                                                        <FaEdit size={16} />
                                                                    </button>
                                                                </>
                                                            ) : (
                                                                <button
                                                                    className="bg-blue-500 text-white px-2 py-1 rounded"
                                                                    onClick={() => handleStartAssignBarcode(member.id)}
                                                                >
                                                                    Assign
                                                                </button>
                                                            )}
                                                        </div>
                                                    )}
                                                    {assigningBarcodeId === member.id && barcodeError && (
                                                        <p className="text-red-600 text-sm">{barcodeError}</p>
                                                    )}
                                                </td>

                                                <td className="px-4 py-3">
                                                    {latestAgreementTimestamp ? (
                                                        (() => {
                                                            const rawDate = getAgreementDate(member);
                                                            const memberDate = typeof rawDate?.toDate === "function" ? rawDate.toDate()
                                                                : rawDate instanceof Date ? rawDate
                                                                    : typeof rawDate === "string" || typeof rawDate === "number"
                                                                        ? new Date(rawDate)
                                                                        : null;

                                                            if (memberDate && memberDate >= latestAgreementTimestamp) {
                                                                return (
                                                                    <span className="text-green-600 font-semibold text-sm">
                                                                        Accepted <br />
                                                                        {memberDate.toLocaleDateString()}
                                                                    </span>
                                                                );
                                                            } else if (memberDate) {
                                                                return (
                                                                    <span className="text-red-600 font-semibold text-sm">
                                                                        New Agreement Not Accepted
                                                                    </span>
                                                                );
                                                            } else {
                                                                return (
                                                                    <span className="text-gray-500 italic text-sm">
                                                                        None of the agreement was accepted

                                                                    </span>
                                                                );
                                                            }
                                                        })()
                                                    ) : (
                                                        <span className="text-gray-500 italic text-sm">Checking...</span>
                                                    )}
                                                </td>



                                                <td className="border border-gray-300 p-2">
                                                    <div className="flex flex-row">
                                                        {editingMemberId === member.id ? (
                                                            <>
                                                                <button
                                                                    onClick={() => handleUpdateMemberStatus(member.id)}
                                                                    className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600 transition duration-300 mr-2"
                                                                >
                                                                    Save
                                                                </button>
                                                                <button
                                                                    onClick={handleCancelEdit}
                                                                    className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 transition duration-300"
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <button
                                                                    onClick={() => {
                                                                        setEditingMemberId(member.id);
                                                                        setNewStatus(member.status || "");
                                                                        setPreviousStatus(member.status || "");
                                                                        setMembershipStartDate(
                                                                            member.membershipStartDate
                                                                                ? member.membershipStartDate.toDate().toISOString().split('T')[0]
                                                                                : ""
                                                                        );
                                                                        setManualEndDate(
                                                                            member.membershipEndDate
                                                                                ? member.membershipEndDate.toDate().toISOString().split('T')[0]
                                                                                : ""
                                                                        );
                                                                        setSelectedClassesIds(member.eligibleClasses || []);
                                                                        setNewClassesRemaining(member.classesRemaining ?? 0);
                                                                        startEditMember(member);
                                                                    }}
                                                                    className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition duration-300 mr-2"
                                                                >
                                                                    Edit
                                                                </button>
                                                                <button
                                                                    onClick={() => openDetailsModal(member)}
                                                                    className="bg-gray-700 text-white px-4 py-2 rounded-md hover:bg-gray-800 transition duration-300"
                                                                >
                                                                    Details
                                                                </button>
                                                            </>
                                                        )}
                                                    </div>
                                                </td>
                                                <td className="border border-gray-300 p-2">
                                                    <div className="flex flex-row">
                                                        <button
                                                            onClick={() => handleArchiveMember(member.id)}
                                                            className="bg-yellow-500 text-white px-4 py-2 rounded-md hover:bg-yellow-600"
                                                        >
                                                            Archive
                                                        </button>

                                                        <ConfirmationModal
                                                            isOpen={isDeleteModalOpen}
                                                            onClose={() => setIsDeleteModalOpen(false)}
                                                            onConfirm={handleConfirmDelete}
                                                            message={`Are you sure you want to delete this ${deleteItemType}?`}
                                                        />
                                                    </div>
                                                </td>


                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        <div className="mt-4 flex justify-center flex-shrink-0">
                                {Array.from({ length: totalPages }, (_, i) => (
                                    <button
                                        key={i}
                                        onClick={() => paginate(i + 1)}
                                        className={`mx-1 px-3 py-1 rounded ${currentPage === i + 1
                                            ? "bg-blue-500 text-white"
                                            : theme === 'dark' ? 'bg-gray-700 text-gray-200 hover:bg-gray-600' : "bg-gray-200 text-gray-800 hover:bg-gray-300"
                                            }`}
                                    >
                                        {i + 1}
                                    </button>
                                ))}
                            </div>
                    </div>
                    {
                        isDetailsModalOpen && selectedMember && (
                            <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center">
                                <div className="bg-white rounded-lg shadow-lg p-8 w-96">
                                    <div className="flex justify-end items-center mb-4">
                                        <button onClick={closeDetailsModal} className="text-red-500 hover:text-gray-700">
                                            <svg className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    </div>


                                    <div className="text-center">
                                        {selectedMember.photo ? (
                                            <img src={selectedMember.photo} alt="Member" className="mx-auto rounded-full h-64 w-64 object-cover mb-4" />
                                        ) : (
                                            <div className="mx-auto rounded-full h-32 w-32 bg-gray-200 flex items-center justify-center mb-4">
                                                <span className="text-gray-500">No Photo</span>
                                            </div>
                                        )}
                                        <h3 className="text-base font-semibold">{selectedMember.name} {selectedMember.lastName}</h3>
                                        <p className="text-sm text-gray-600">{selectedMember.email}</p>
                                    </div>

                                    <div className="mt-6 text-sm">
                                        <p><strong>Contact:</strong> {selectedMember.phone || 'N/A'}</p>
                                        <p><strong>Emergency Contact:</strong> {selectedMember.emergencyContact || 'N/A'}</p>
                                        <p><strong>Emergency Contact RelationShip:</strong> {selectedMember.emergencyContactRelation || 'N/A'}</p>
                                        <p><strong>Membership Type:</strong> {selectedMember.status || 'N/A'}</p>

                                    </div>
                                </div>
                            </div>
                        )
                    }
                </LoadingOverlay >
            )
            }

            {
                tab === "coaches" && (
                    <LoadingOverlay isLoading={isLoading}>
                        <div className="p-3 sm:p-4 lg:p-6 h-full overflow-auto">
                        <div className="overflow-x-auto overflow-y-visible">
                            <table className="w-full text-sm">
                                <thead>
                                    <tr className="bg-gradient-to-r from-blue-500 to-blue-600 text-white">
                                        <th className="px-4 py-2 text-left">Name</th>
                                        <th className="px-4 py-2 text-left">Email</th>
                                        <th className="px-4 py-2 text-left">Phone</th>
                                        <th className="px-4 py-2 text-left">Is Instructor</th>
                                        <th className="px-4 py-2 text-left">Is Active Coach</th>
                                        <th className="px-4 py-2 text-left">Categories</th>
                                        <th className="px-4 py-2 text-left">Assign Barcode</th>
                                        <th className="px-4 py-2 text-left">Agreement</th>
                                        <th className="px-4 py-2 text-left">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {activeCoaches.map((coach) => (
                                        <tr key={coach.id} className={`border-b ${
                                            theme === 'dark' ? 'border-gray-700' : 'border-gray-200'
                                        }`}>
                                            <td className={`px-4 py-2 ${
                                                theme === 'dark' ? 'text-white' : 'text-gray-900'
                                            }`}>{coach.name}</td>
                                            <td className={`px-4 py-2 ${
                                                theme === 'dark' ? 'text-white' : 'text-gray-900'
                                            }`}>{coach.email}</td>
                                            <td className={`px-4 py-2 ${
                                                theme === 'dark' ? 'text-white' : 'text-gray-900'
                                            }`}>{coach.phone}</td>
                                            <td className="px-4 py-2">
                                                <label className="flex items-center cursor-pointer">
                                                    <div className="relative">
                                                        <input
                                                            type="checkbox"
                                                            className="sr-only"
                                                            checked={coach.isCoach}
                                                            disabled={isSecAdmin}
                                                            onChange={() => handleToggleCoach(coach.id)}
                                                        />
                                                        <div className={`block w-14 h-8 rounded-full ${coach.isCoach ? 'bg-green-400' : 'bg-gray-400'}`}></div>
                                                        <div className={`absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition-transform ${coach.isCoach ? 'transform translate-x-6' : ''}`}></div>
                                                    </div>
                                                    <span className={`ml-3 text-sm font-medium ${
                                                        theme === 'dark' ? 'text-white' : 'text-gray-900'
                                                    }`}>
                                                        {coach.isCoach ? 'Yes' : 'No'}
                                                    </span>
                                                </label>
                                            </td>
                                            <td className="px-4 py-2">
                                                <label className="flex items-center cursor-pointer">
                                                    <div className="relative">
                                                        <input
                                                            type="checkbox"
                                                            className="sr-only"
                                                            checked={coach.isActiveCoach}
                                                            disabled={isSecAdmin}
                                                            onChange={() => handleInactiveCoach(coach.id)}
                                                        />
                                                        <div className={`block w-14 h-8 rounded-full ${coach.isActiveCoach ? 'bg-green-400' : 'bg-gray-400'}`}></div>
                                                        <div className={`absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition-transform ${coach.isActiveCoach ? 'transform translate-x-6' : ''}`}></div>
                                                    </div>
                                                    <span className={`ml-3 text-sm font-medium ${
                                                        theme === 'dark' ? 'text-white' : 'text-gray-900'
                                                    }`}>
                                                        {coach.isActiveCoach ? 'Yes' : 'No'}
                                                    </span>
                                                </label>
                                            </td>
                                            <td className="px-4 py-2 min-w-[180px]">
                                                <Select
                                                    mode="multiple"
                                                    value={Array.isArray(coach.categories) ? coach.categories : []}
                                                    onChange={vals => handleUpdateCoachCategories(coach.id, vals)}
                                                    disabled={isSecAdmin}
                                                    style={{ width: '100%' }}
                                                    placeholder="Assign categories"
                                                    options={categories.map(cat => ({ label: cat.name, value: cat.name }))}
                                                    size="small"
                                                />
                                            </td>
                                            <td className="px-4 py-3">
                                                {assigningBarcodeId === coach.id ? (
                                                    <div className="flex items-center space-x-2">
                                                        <input
                                                            ref={barcodeInputRef}
                                                            type="text"
                                                            value={scannedBarcode}
                                                            onChange={handleBarcodeInput}
                                                            placeholder="Scan or enter barcode"
                                                            className={`border px-2 py-1 rounded w-32 ${
                                                                theme === 'dark' ? 'bg-gray-700 text-white border-gray-600 placeholder-gray-400' : 'bg-white text-gray-900 border-gray-300'
                                                            }`}
                                                            autoFocus
                                                        />
                                                        <button
                                                            className="text-green-600 text-xl"
                                                            title="Save"
                                                            onClick={() => handleSaveBarcode(coach.id, "coach")}
                                                        >
                                                            <FaCheck />
                                                        </button>
                                                        <button
                                                            className="text-red-600 text-xl"
                                                            title="Cancel"
                                                            onClick={handleCancelBarcode}
                                                        >
                                                            <FaTimes />
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div className="flex items-center space-x-2">
                                                        {coach.barcode ? (
                                                            <>
                                                                <span className="text-green-600 font-semibold">{coach.barcode}</span>
                                                                <button
                                                                    onClick={() => handleStartAssignBarcode(coach.id, coach.barcode)}
                                                                    title="Edit Barcode"
                                                                    className={theme === 'dark' ? 'text-gray-300 hover:text-white' : ''}
                                                                >
                                                                    <FaEdit size={16} />
                                                                </button>
                                                            </>
                                                        ) : (
                                                            <button
                                                                className="bg-blue-500 text-white px-2 py-1 rounded"
                                                                onClick={() => handleStartAssignBarcode(coach.id)}
                                                            >
                                                                Assign
                                                            </button>
                                                        )}
                                                    </div>
                                                )}
                                                {assigningBarcodeId === coach.id && barcodeError && (
                                                    <span className="text-red-600 text-sm">{barcodeError}</span>
                                                )}
                                            </td>
                                            <td className="px-4 py-3">
                                                {latestAgreementTimestampInstructor ? (
                                                    (() => {
                                                        const rawDate = getAgreementDateInstructor(coach);
                                                        const coachDate = typeof rawDate?.toDate === "function" ? rawDate.toDate()
                                                            : rawDate instanceof Date ? rawDate
                                                                : typeof rawDate === "string" || typeof rawDate === "number"
                                                                    ? new Date(rawDate)
                                                                    : null;

                                                        if (coachDate && coachDate >= latestAgreementTimestampInstructor) {
                                                            return (
                                                                <span className="text-green-600 font-semibold text-sm">
                                                                    Accepted <br />
                                                                    {coachDate.toLocaleDateString()}
                                                                </span>
                                                            );
                                                        } else if (coachDate) {
                                                            return (
                                                                <span className="text-red-600 font-semibold text-sm">
                                                                    New Agreement Not Accepted
                                                                </span>
                                                            );
                                                        } else {
                                                            return (
                                                                <span className="text-gray-500 italic text-sm">
                                                                    None of the agreement was accepted

                                                                </span>
                                                            );
                                                        }
                                                    })()
                                                ) : (
                                                    <span className="text-gray-500 italic text-sm">Checking...</span>
                                                )}
                                            </td>
                                            <td className="px-4 py-3">
                                                <button
                                                    onClick={() => handleArchiveCoach(coach.id)}
                                                    className="bg-yellow-500 text-white px-3 py-1 rounded-md hover:bg-yellow-600"
                                                    title="Archive Instructor"
                                                >
                                                    Archive
                                                </button>
                                            </td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        </div>
                    </LoadingOverlay>

                )
            }

            {
                tab === 'schedule' && (
                    <LoadingOverlay isLoading={isLoading}>
                        <div className="p-3 sm:p-4 lg:p-6 h-full overflow-auto">
                        <ClassSchedule
                            classSchedule={classSchedule}
                            setClassSchedule={setClassSchedule}
                            coaches={coaches}
                            isSecAdmin={isSecAdmin}
                            theme={theme}
                        />
                        </div>
                    </LoadingOverlay>
                )
            }

            {
                tab === "stripeExport" && (
                    <div className="p-4 pb-8">
                        <div className={`shadow rounded-lg border mb-4 ${
                            theme === 'dark' ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
                        }`}>
                            <div className={`bg-blue-500 px-4 py-3 border-b ${
                                theme === 'dark' ? 'border-gray-700' : 'border-gray-200'
                            }`}>
                                <h3 className="text-lg font-semibold text-white">Stripe Data Export</h3>
                            </div>
                            <div className="p-4 space-y-4">
                                <p className={theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}>
                                    Export your existing Stripe customers, subscriptions, products, and prices to Firestore for migration.
                                </p>
                                <button
                                    onClick={handleExportStripeData}
                                    disabled={stripeExportLoading}
                                    className={`px-4 py-2 rounded-lg text-white font-semibold transition ${
                                        stripeExportLoading ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'
                                    }`}
                                >
                                    {stripeExportLoading ? 'Exporting...' : 'Export Stripe Data'}
                                </button>
                                {stripeExportMessage && (
                                    <div className="p-3 rounded-md bg-green-100 text-green-800">
                                        {stripeExportMessage}
                                    </div>
                                )}
                                {stripeExportError && (
                                    <div className="p-3 rounded-md bg-red-100 text-red-800">
                                        {stripeExportError}
                                    </div>
                                )}
                                {/* <p className={theme === 'dark' ? 'text-gray-400 text-sm' : 'text-gray-500 text-sm'}>
                                    Make sure the function is deployed and Stripe is configured in your Firebase environment.
                                </p> */}
                            </div>
                        </div>
                    </div>
                )
            }

            {
                tab === "paymentStatus" && (
                    <LoadingOverlay isLoading={!membersLoaded}>
                    <div className="p-4 pb-8">
                        <div className={`shadow rounded-lg border mb-4 ${
                            theme === 'dark' ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
                        }`}>
                            <div className={`bg-blue-500 px-4 py-3 border-b ${
                                theme === 'dark' ? 'border-gray-700' : 'border-gray-200'
                            }`}>
                                <h3 className="text-lg font-semibold text-white">Member Payment Status</h3>
                            </div>
                            <div className="p-4">
                                <div className={`mb-4 rounded-3xl border p-4 ${theme === 'dark' ? 'bg-gray-800 border-gray-700' : 'bg-slate-50 border-slate-200'}`}>
                                    <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
                                        <div>
                                            <h4 className={`font-semibold ${theme === 'dark' ? 'text-white' : 'text-slate-900'}`}>
                                                Import new Stripe transactions
                                            </h4>
                                            <p className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-slate-600'}`}>
                                                Export Stripe data for the latest transactions and refresh the payment status table.
                                            </p>
                                            {lastStripeSync && (
                                                <p className={`text-xs mt-2 ${theme === 'dark' ? 'text-gray-500' : 'text-slate-500'}`}>
                                                    ✓ Last synced: {lastStripeSync.toLocaleString()}
                                                </p>
                                            )}
                                        </div>
                                        <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                                            <button
                                                onClick={handleExportStripeData}
                                                disabled={stripeExportLoading}
                                                className={`inline-flex items-center justify-center rounded-full px-4 py-2 text-sm font-semibold transition ${
                                                    stripeExportLoading
                                                        ? 'cursor-not-allowed bg-slate-400 text-white'
                                                        : theme === 'dark'
                                                            ? 'bg-blue-500 text-white hover:bg-blue-600'
                                                            : 'bg-blue-600 text-white hover:bg-blue-700'
                                                }`}
                                            >
                                                {stripeExportLoading ? 'Refreshing…' : 'Import Stripe Data'}
                                            </button>
                                            {stripeExportMessage && (
                                                <span className={`text-sm ${theme === 'dark' ? 'text-emerald-300' : 'text-emerald-700'}`}>
                                                    {stripeExportMessage}
                                                </span>
                                            )}
                                            {stripeExportError && (
                                                <span className={`text-sm ${theme === 'dark' ? 'text-red-300' : 'text-red-700'}`}>
                                                    {stripeExportError}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {!stripeData ? (
                                    <p className={theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}>
                                        No Stripe data available. Please export Stripe data first.
                                    </p>
                                ) : (
                                    <div>
                                        {/* Status Legend */}
                                        <div className={`mb-4 p-4 rounded-2xl border ${
                                            theme === 'dark'
                                                ? 'bg-slate-900 border-slate-700 shadow-sm shadow-black/10'
                                                : 'bg-slate-50 border-slate-200 shadow-sm'
                                        }`}>
                                            <div className="flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
                                                <div>
                                                    <h4 className={`text-sm font-semibold ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>Status Legend</h4>
                                                    <p className={`mt-1 text-xs ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
                                                        Payment status definitions
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="mt-3 grid gap-2 lg:grid-cols-2">
                                                <div className={`rounded-2xl p-3 ${theme === 'dark' ? 'bg-slate-800 border border-slate-700' : 'bg-white border border-slate-200'}`}>
                                                    <h5 className={`mb-2 text-xs font-semibold uppercase tracking-wide ${theme === 'dark' ? 'text-gray-100' : 'text-slate-800'}`}>
                                                        Subscription Status
                                                    </h5>
                                                    <div className="space-y-2">
                                                        <div className="flex items-start gap-2">
                                                            <span className="inline-flex h-6 items-center rounded-full bg-emerald-100 px-2 text-xs font-semibold text-emerald-800 flex-shrink-0">active</span>
                                                            <p className={`text-xs leading-5 ${theme === 'dark' ? 'text-gray-300' : 'text-slate-700'}`}>
                                                                Subscription active
                                                            </p>
                                                        </div>
                                                        <div className="flex items-start gap-2">
                                                            <span className="inline-flex h-6 items-center rounded-full bg-red-100 px-2 text-xs font-semibold text-red-800 flex-shrink-0">canceled</span>
                                                            <p className={`text-xs leading-5 ${theme === 'dark' ? 'text-gray-300' : 'text-slate-700'}`}>
                                                                Subscription canceled
                                                            </p>
                                                        </div>
                                                        <div className="flex items-start gap-2">
                                                            <span className="inline-flex h-6 items-center rounded-full bg-amber-100 px-2 text-xs font-semibold text-amber-800 flex-shrink-0">past_due</span>
                                                            <p className={`text-xs leading-5 ${theme === 'dark' ? 'text-gray-300' : 'text-slate-700'}`}>
                                                                Payment overdue
                                                            </p>
                                                        </div>
                                                        <div className="flex items-start gap-2">
                                                            <span className={`inline-flex h-6 items-center rounded-full px-2 text-xs font-semibold flex-shrink-0 ${theme === 'dark' ? 'bg-gray-600 text-gray-200' : 'bg-slate-100 text-slate-700'}`}>
                                                                None
                                                            </span>
                                                            <p className={`text-xs leading-5 ${theme === 'dark' ? 'text-gray-300' : 'text-slate-700'}`}>
                                                                No active subscription
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className={`rounded-2xl p-3 ${theme === 'dark' ? 'bg-slate-800 border border-slate-700' : 'bg-white border border-slate-200'}`}>
                                                    <h5 className={`mb-2 text-xs font-semibold uppercase tracking-wide ${theme === 'dark' ? 'text-gray-100' : 'text-slate-800'}`}>
                                                        Payment Status
                                                    </h5>
                                                    <div className="space-y-2">
                                                        <div className="flex items-start gap-2">
                                                            <span className="inline-flex h-6 items-center rounded-full bg-emerald-100 px-2 text-xs font-semibold text-emerald-800 flex-shrink-0">succeeded</span>
                                                            <p className={`text-xs leading-5 ${theme === 'dark' ? 'text-gray-300' : 'text-slate-700'}`}>
                                                                Successful payment
                                                            </p>
                                                        </div>
                                                        <div className="flex items-start gap-2">
                                                            <span className="inline-flex h-6 items-center rounded-full bg-red-100 px-2 text-xs font-semibold text-red-800 flex-shrink-0">failed</span>
                                                            <p className={`text-xs leading-5 ${theme === 'dark' ? 'text-gray-300' : 'text-slate-700'}`}>
                                                                Payment failed
                                                            </p>
                                                        </div>
                                                        <div className="flex items-start gap-2">
                                                            <span className="inline-flex h-6 items-center rounded-full bg-orange-100 px-2 text-xs font-semibold text-orange-800 flex-shrink-0">canceled</span>
                                                            <p className={`text-xs leading-5 ${theme === 'dark' ? 'text-gray-300' : 'text-slate-700'}`}>
                                                                Payment canceled
                                                            </p>
                                                        </div>
                                                        <div className="flex items-start gap-2">
                                                            <span className="inline-flex h-6 items-center rounded-full bg-sky-100 px-2 text-xs font-semibold text-sky-800 flex-shrink-0">processing</span>
                                                            <p className={`text-xs leading-5 ${theme === 'dark' ? 'text-gray-300' : 'text-slate-700'}`}>
                                                                Still processing
                                                            </p>
                                                        </div>
                                                        <div className="flex items-start gap-2">
                                                            <span className="inline-flex h-6 items-center rounded-full bg-amber-100 px-2 text-xs font-semibold text-amber-800 flex-shrink-0">requires_payment</span>
                                                            <p className={`text-xs leading-5 ${theme === 'dark' ? 'text-gray-300' : 'text-slate-700'}`}>
                                                                Needs new payment method
                                                            </p>
                                                        </div>
                                                    </div>


                                                    </div>
                                                </div>
                                            </div>
                                            
                                        

                                        {/* Membership Type Tabs */}
                                        {(() => {
                                            const activePaymentMembers = members.filter(member => {
                                                const status = String(member.status || '').trim();
                                                const lowerStatus = status.toLowerCase();
                                                const isArchived = member.archived === true;

                                                return (
                                                    !isArchived &&
                                                    status &&
                                                    lowerStatus !== 'not set' &&
                                                    lowerStatus !== 'expired' &&
                                                    lowerStatus !== 'archived'
                                                );
                                            });

                                            const membershipTypes = [...new Set(
                                                activePaymentMembers
                                                    .map(m => String(m.status || '').trim())
                                                    .filter(s => s && s.toLowerCase() !== 'not set')
                                            )].sort();

                                            const currentMembershipTab = membershipTypes.includes(selectedMembershipTab)
                                                ? selectedMembershipTab
                                                : membershipTypes[0] || '';

                                            return (
                                                <div>
                                                    {/* Tabs Navigation */}
                                                    <div className={`flex gap-2 mb-6 pb-3 border-b flex-wrap ${
                                                        theme === 'dark' ? 'border-gray-700' : 'border-gray-300'
                                                    }`}>
                                                        {membershipTypes.map(membershipType => (
                                                            <button
                                                                key={membershipType}
                                                                onClick={() => setSelectedMembershipTab(membershipType)}
                                                                className={`px-4 py-2 rounded-t-lg font-semibold transition ${
                                                                    currentMembershipTab === membershipType
                                                                        ? theme === 'dark' 
                                                                            ? 'bg-blue-700 text-white border-b-2 border-blue-400' 
                                                                            : 'bg-blue-500 text-white border-b-2 border-blue-700'
                                                                        : theme === 'dark'
                                                                            ? 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                                                                            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                                                                }`}
                                                            >
                                                                 {membershipType}
                                                            </button>
                                                        ))}
                                                    </div>

                                                    {/* Payment Status Filter */}
                                                    <div className={`mb-4 p-3 rounded-2xl border ${theme === 'dark' ? 'bg-slate-900 border-slate-700' : 'bg-white border-slate-200'} shadow-sm`}>
                                                        <div className="flex items-center gap-4">
                                                            <label className={`font-medium ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                                                                Filter by Payment Status:
                                                            </label>
                                                            <select
                                                                value={paymentStatusFilter}
                                                                onChange={(e) => setPaymentStatusFilter(e.target.value)}
                                                                className={`px-3 py-1 rounded border text-sm ${
                                                                    theme === 'dark' 
                                                                        ? 'bg-gray-700 border-gray-600 text-white' 
                                                                        : 'bg-white border-gray-300 text-gray-900'
                                                                }`}
                                                            >
                                                                <option value="All">All Payments</option>
                                                                <option value="succeeded">Successful Only</option>
                                                                <option value="failed">Failed Only</option>
                                                                <option value="processing">Processing Only</option>
                                                                <option value="canceled">Canceled Only</option>
                                                                <option value="requires_payment_method">Requires Payment Method</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    {/* Table for Selected Membership Type */}
                                                    <div className={`overflow-x-auto rounded-3xl border ${theme === 'dark' ? 'border-slate-700 bg-slate-950' : 'border-slate-200 bg-white'} shadow-sm`}>
                                                        <table className="min-w-full divide-y divide-slate-200 text-sm">
                                                            <thead>
                                                                <tr className={theme === 'dark' ? 'bg-slate-900 text-slate-100' : 'bg-slate-800 text-white'}>
                                                                    <th colSpan="2" className="px-4 py-3 text-left font-semibold border-b border-slate-700">
                                                                        <div className="flex items-center gap-2">
                                                                            <FaUsers className="text-base" />
                                                                            <span>Member Details</span>
                                                                        </div>
                                                                    </th>
                                                                    <th colSpan="12" className="px-4 py-3 text-left font-semibold border-b border-slate-700">
                                                                        <div className="flex items-center gap-2">
                                                                            <FaCreditCard className="text-base" />
                                                                            <span>Stripe Details</span>
                                                                        </div>
                                                                    </th>
                                                                </tr>

                                                                <tr className={theme === 'dark' ? 'bg-slate-900 text-slate-100' : 'bg-slate-100 text-slate-900'}>
                                                                    <th scope="col" className="px-4 py-3 border-r text-left font-semibold uppercase tracking-[0.08em]">Member Name</th>
                                                                    <th scope="col" className="px-4 py-3 border-r text-left font-semibold uppercase tracking-[0.08em]">Member Email</th>
                                                                    <th scope="col" className="px-4 py-3 border-r text-left font-semibold uppercase tracking-[0.08em]">Subscription Frequency</th>
                                                                    <th scope="col" className="px-4 py-3 border-r text-left font-semibold uppercase tracking-[0.08em]">Stripe Customer Name</th>
                                                                    <th scope="col" className="px-4 py-3 border-r text-left font-semibold uppercase tracking-[0.08em]">Stripe Email</th>
                                                                    <th scope="col" className="px-4 py-3 border-r text-left font-semibold uppercase tracking-[0.08em]">Stripe Customer ID</th>
                                                                    <th scope="col" className="px-4 py-3 border-r text-left font-semibold uppercase tracking-[0.08em]">Online Paid Status</th>
                                                                    <th colSpan="2" className="px-4 py-3 border-r text-center font-semibold uppercase tracking-[0.08em]">Price</th>
                                                                    <th colSpan="4" className="px-4 py-3 border-r text-center font-semibold uppercase tracking-[0.08em]">Payment History</th>
                                                                    <th scope="col" className="px-4 py-3 text-left font-semibold uppercase tracking-[0.08em]">Status</th>
                                                                </tr>

                                                                <tr className={theme === 'dark' ? 'bg-slate-800 text-slate-100 text-[10px] uppercase tracking-[0.14em]' : 'bg-slate-100 text-slate-700 text-[10px] uppercase tracking-[0.14em]'}>
                                                                    <th colSpan="3" className="px-4 py-2 border-r"></th>
                                                                    <th colSpan="3" className="px-4 py-2 border-r"></th>
                                                                    <th className="px-4 py-2 border-r text-center">Online Paid</th>
                                                                    <th className="px-4 py-2 border-r text-center">Product Price</th>
                                                                    <th className="px-4 py-2 border-r text-center">Latest Paid</th>
                                                                    <th className="px-4 py-2 border-r text-center">Latest Payment</th>
                                                                    <th className="px-4 py-2 border-r text-center">Previous 1</th>
                                                                    <th className="px-4 py-2 border-r text-center">Previous 2</th>
                                                                    <th className="px-4 py-2 border-r text-center">Previous 3</th>
                                                                    <th className="px-4 py-2"></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {activePaymentMembers
                                                                    .filter(m => m.status === currentMembershipTab)
                                                                    .filter(member => {
                                                                        if (paymentStatusFilter === 'All') return true;

                                                                        const stripeCustomer = getStripeCustomerForMember(member);
                                                                        if (!stripeCustomer) return false;

                                                                        const memberPayments = getMemberPaymentIntents(member);
                                                                        if (!memberPayments.length) return false;

                                                                        return memberPayments.some(pi => pi.status === paymentStatusFilter);
                                                                    })
                                                                    .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
                                                                    .map((member) => {
                                                                        const stripeCustomer = getStripeCustomerForMember(member);
                                                                        const subscription = stripeCustomer 
                                                                            ? stripeData.subscriptions?.find(s => s.customer === stripeCustomer.id) 
                                                                            : null;
                                                                        const subscriptionItems = subscription?.items?.data || [];
                                                                        const priceInfo = subscriptionItems.length > 0 
                                                                            ? stripeData.prices?.find(p => p.id === subscriptionItems[0].price.id) 
                                                                            : null;
                                                                        const interval = priceInfo?.recurring?.interval || 'N/A';
                                                                        const intervalCount = priceInfo?.recurring?.interval_count || 1;
                                                                        const productPrice = priceInfo?.unit_amount ? `$${(priceInfo.unit_amount / 100).toFixed(2)}` : 'N/A';
                                                                        const latestPayment = getLatestRelevantPayment(member);
                                                                        const payments = getMemberPaymentIntents(member);
                                                                        const manualPaidStatus = member.manualPaymentStatus || 'Not Set';
                                                                        
                                                                        return (
                                                                            <tr key={member.id} className={`border-b ${
                                                                                theme === 'dark' ? 'border-slate-700 odd:bg-slate-950 even:bg-slate-900 hover:bg-slate-800' : 'border-slate-200 odd:bg-white even:bg-slate-50 hover:bg-slate-100'
                                                                            }`}>
                                                                                {/* Member Details */}
                                                                                <td className={`px-3 py-2 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                                                                                    {member.name} {member.lastName}
                                                                                </td>
                                                                                <td className={`px-3 py-2 text-xs ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
                                                                                    {member.email}
                                                                                </td>
                                                                                <td className={`px-3 py-2 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                                                                                    {intervalCount > 1 ? `Every ${intervalCount} ${interval}s` : interval}
                                                                                </td>
                                                                                
                                                                                {/* Stripe Details */}
                                                                                <td className={`px-3 py-2 max-w-xs truncate ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`} title={stripeCustomer?.name || 'N/A'}>
                                                                                    {stripeCustomer?.name || 'N/A'}
                                                                                </td>
                                                                                <td className={`px-3 py-2 text-xs ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
                                                                                    {stripeCustomer?.email || 'N/A'}
                                                                                </td>
                                                                                <td className={`px-3 py-2 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                                                                                    {editingStripeIds[member.id] !== false && editingStripeIds[member.id] !== undefined ? (
                                                                                        <div className="flex items-center gap-1 flex-wrap">
                                                                                            <Input
                                                                                                value={editingStripeIds[member.id] || ''}
                                                                                                onChange={(e) => setEditingStripeIds({ ...editingStripeIds, [member.id]: e.target.value })}
                                                                                                placeholder="ID"
                                                                                                size="small"
                                                                                                autoFocus
                                                                                                className="flex-1 min-w-[100px]"
                                                                                            />
                                                                                            <button
                                                                                                onClick={() => handleSaveStripeId(member.id, editingStripeIds[member.id])}
                                                                                                className="bg-green-500 text-white px-2 py-0.5 rounded text-xs hover:bg-green-600 flex-shrink-0"
                                                                                            >
                                                                                                <FaCheck className="inline" />
                                                                                            </button>
                                                                                            <button
                                                                                                onClick={() => handleCancelStripeIdEdit(member.id)}
                                                                                                className="bg-red-500 text-white px-2 py-0.5 rounded text-xs hover:bg-red-600 flex-shrink-0"
                                                                                            >
                                                                                                <FaTimes className="inline" />
                                                                                            </button>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div className="flex items-center gap-1" title={stripeCustomer?.id || 'Not Linked'}>
                                                                                            <span className="text-xs font-mono cursor-pointer hover:underline" onClick={() => {
                                                                                                const currentValue = member.stripeCustomerId || '';
                                                                                                setOriginalStripeId(currentValue);
                                                                                                setEditingStripeIds({ ...editingStripeIds, [member.id]: currentValue });
                                                                                            }}>
                                                                                                {stripeCustomer ? (stripeCustomer.id.length > 10 ? stripeCustomer.id.substring(0, 10) + '...' : stripeCustomer.id) : 'Not Linked'}
                                                                                            </span>
                                                                                            <Button
                                                                                                size="small"
                                                                                                onClick={() => {
                                                                                                    const currentValue = member.stripeCustomerId || '';
                                                                                                    setOriginalStripeId(currentValue);
                                                                                                    setEditingStripeIds({ ...editingStripeIds, [member.id]: currentValue });
                                                                                                }}
                                                                                                icon={<FaEdit />}
                                                                                                type="text"
                                                                                            />
                                                                                        </div>
                                                                                    )}
                                                                                </td>
                                                                                
                                                                                <td className={`px-3 py-2 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                                                                                    {stripeCustomer ? (
                                                                                        <span className="text-xs text-gray-500 italic">Stripe linked</span>
                                                                                    ) : (
                                                                                        <select
                                                                                            value={manualPaidStatus}
                                                                                            onChange={(e) => handleManualPaymentStatusChange(member.id, e.target.value)}
                                                                                            className={`w-full rounded border px-2 py-1 text-xs ${theme === 'dark' ? 'bg-gray-800 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-900'}`}
                                                                                        >
                                                                                            <option value="Not Set">Not Set</option>
                                                                                            <option value="Paid">Paid</option>
                                                                                            <option value="Unpaid">Unpaid</option>
                                                                                        </select>
                                                                                    )}
                                                                                </td>
                                                                                <td className={`px-3 py-2 text-center text-xs ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
                                                                                    {productPrice}
                                                                                </td>
                                                                                <td className={`px-3 py-2 text-center font-semibold ${
                                                                                    latestPayment?.status === 'succeeded' 
                                                                                        ? (theme === 'dark' ? 'text-green-400' : 'text-green-600')
                                                                                        : latestPayment?.status === 'failed'
                                                                                            ? (theme === 'dark' ? 'text-red-400' : 'text-red-600')
                                                                                            : (theme === 'dark' ? 'text-yellow-400' : 'text-yellow-600')
                                                                                }`}>
                                                                                    {latestPayment ? `$${(latestPayment.amount / 100).toFixed(2)}` : '—'}
                                                                                    {latestPayment && (
                                                                                        <div className={`text-xs px-1 py-0.5 rounded mt-1 inline-block ${
                                                                                            latestPayment.status === 'succeeded' 
                                                                                                ? 'bg-green-100 text-green-800'
                                                                                                : latestPayment.status === 'failed'
                                                                                                    ? 'bg-red-100 text-red-800'
                                                                                                    : latestPayment.status === 'canceled'
                                                                                                        ? 'bg-orange-100 text-orange-800'
                                                                                                        : latestPayment.status === 'processing'
                                                                                                            ? 'bg-blue-100 text-blue-800'
                                                                                                            : 'bg-yellow-100 text-yellow-800'
                                                                                        }`}>
                                                                                            {latestPayment.status}
                                                                                        </div>
                                                                                    )}
                                                                                </td>
                                                                                
                                                                                {/* Payment Columns (1-4) */}
                                                                                <td className={`px-3 py-2 text-center text-xs border-r ${theme === 'dark' ? 'border-gray-700' : 'border-gray-300'}`}>
                                                                                    {latestPayment ? (() => {
                                                                                        const latestPaymentDetail = latestPayment.last_payment_error?.message || latestPayment.failure_message || latestPayment.charges?.data?.[0]?.failure_message || latestPayment.charges?.data?.[0]?.outcome?.seller_message || latestPayment.charges?.data?.[0]?.failure_code || null;
                                                                                        return (
                                                                                            <div>
                                                                                                <div className={`font-semibold ${
                                                                                                    latestPayment.status === 'succeeded' 
                                                                                                        ? (theme === 'dark' ? 'text-green-400' : 'text-green-600')
                                                                                                        : latestPayment.status === 'failed'
                                                                                                            ? (theme === 'dark' ? 'text-red-400' : 'text-red-600')
                                                                                                            : (theme === 'dark' ? 'text-yellow-400' : 'text-yellow-600')
                                                                                                }`}>
                                                                                                    ${(latestPayment.amount / 100).toFixed(2)}
                                                                                                </div>
                                                                                                <div className={theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}>
                                                                                                    {latestPayment.paymentDate.toLocaleDateString()}
                                                                                                </div>
                                                                                                <div className={`text-xs px-1 py-0.5 rounded mt-1 inline-block ${
                                                                                                    latestPayment.status === 'succeeded' 
                                                                                                        ? 'bg-green-100 text-green-800'
                                                                                                        : latestPayment.status === 'failed'
                                                                                                            ? 'bg-red-100 text-red-800'
                                                                                                            : latestPayment.status === 'canceled'
                                                                                                                ? 'bg-orange-100 text-orange-800'
                                                                                                                : latestPayment.status === 'processing'
                                                                                                                    ? 'bg-blue-100 text-blue-800'
                                                                                                                    : 'bg-yellow-100 text-yellow-800'
                                                                                                }`}>
                                                                                                    {latestPayment.status}
                                                                                                </div>
                                                                                                {latestPaymentDetail && (
                                                                                                    <div className={`mt-2 rounded-xl px-2 py-1 text-[11px] leading-5 ${
                                                                                                        theme === 'dark' ? 'bg-white/5 text-gray-200 border border-gray-700' : 'bg-slate-100 text-slate-700 border border-slate-200'
                                                                                                    }`}>
                                                                                                        {latestPaymentDetail}
                                                                                                    </div>
                                                                                                )}
                                                                                            </div>
                                                                                        );
                                                                                    })() : '—'}
                                                                                </td>
                                                                                <td className={`px-3 py-2 text-center text-xs border-r ${theme === 'dark' ? 'border-gray-700' : 'border-gray-300'}`}>
                                                                                    {payments[1] ? (
                                                                                        <div>
                                                                                            <div className={`${
                                                                                                payments[1].status === 'succeeded' 
                                                                                                    ? (theme === 'dark' ? 'text-green-400' : 'text-green-600')
                                                                                                    : payments[1].status === 'failed'
                                                                                                        ? (theme === 'dark' ? 'text-red-400' : 'text-red-600')
                                                                                                        : (theme === 'dark' ? 'text-yellow-400' : 'text-yellow-600')
                                                                                            }`}>
                                                                                                ${(payments[1].amount / 100).toFixed(2)}
                                                                                            </div>
                                                                                            <div className={theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}>
                                                                                                {payments[1].paymentDate.toLocaleDateString()}
                                                                                            </div>
                                                                                            <div className={`text-xs px-1 py-0.5 rounded mt-1 inline-block ${
                                                                                                payments[1].status === 'succeeded' 
                                                                                                    ? 'bg-green-100 text-green-800'
                                                                                                    : payments[1].status === 'failed'
                                                                                                        ? 'bg-red-100 text-red-800'
                                                                                                        : payments[1].status === 'canceled'
                                                                                                            ? 'bg-orange-100 text-orange-800'
                                                                                                            : payments[1].status === 'processing'
                                                                                                                ? 'bg-blue-100 text-blue-800'
                                                                                                                : 'bg-yellow-100 text-yellow-800'
                                                                                            }`}>
                                                                                                {payments[1].status}
                                                                                            </div>
                                                                                        </div>
                                                                                    ) : '—'}
                                                                                </td>
                                                                                <td className={`px-3 py-2 text-center text-xs border-r ${theme === 'dark' ? 'border-gray-700' : 'border-gray-300'}`}>
                                                                                    {payments[2] ? (
                                                                                        <div>
                                                                                            <div className={`${
                                                                                                payments[2].status === 'succeeded' 
                                                                                                    ? (theme === 'dark' ? 'text-green-400' : 'text-green-600')
                                                                                                    : payments[2].status === 'failed'
                                                                                                        ? (theme === 'dark' ? 'text-red-400' : 'text-red-600')
                                                                                                        : (theme === 'dark' ? 'text-yellow-400' : 'text-yellow-600')
                                                                                            }`}>
                                                                                                ${(payments[2].amount / 100).toFixed(2)}
                                                                                            </div>
                                                                                            <div className={theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}>
                                                                                                {payments[2].paymentDate.toLocaleDateString()}
                                                                                            </div>
                                                                                            <div className={`text-xs px-1 py-0.5 rounded mt-1 inline-block ${
                                                                                                payments[2].status === 'succeeded' 
                                                                                                    ? 'bg-green-100 text-green-800'
                                                                                                    : payments[2].status === 'failed'
                                                                                                        ? 'bg-red-100 text-red-800'
                                                                                                        : payments[2].status === 'canceled'
                                                                                                            ? 'bg-orange-100 text-orange-800'
                                                                                                            : payments[2].status === 'processing'
                                                                                                                ? 'bg-blue-100 text-blue-800'
                                                                                                                : 'bg-yellow-100 text-yellow-800'
                                                                                            }`}>
                                                                                                {payments[2].status}
                                                                                            </div>
                                                                                        </div>
                                                                                    ) : '—'}
                                                                                </td>
                                                                                <td className={`px-3 py-2 text-center text-xs ${theme === 'dark' ? 'border-gray-700' : 'border-gray-300'}`}>
                                                                                    {payments[3] ? (
                                                                                        <div>
                                                                                            <div className={`${
                                                                                                payments[3].status === 'succeeded' 
                                                                                                    ? (theme === 'dark' ? 'text-green-400' : 'text-green-600')
                                                                                                    : payments[3].status === 'failed'
                                                                                                        ? (theme === 'dark' ? 'text-red-400' : 'text-red-600')
                                                                                                        : (theme === 'dark' ? 'text-yellow-400' : 'text-yellow-600')
                                                                                            }`}>
                                                                                                ${(payments[3].amount / 100).toFixed(2)}
                                                                                            </div>
                                                                                            <div className={theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}>
                                                                                                {payments[3].paymentDate.toLocaleDateString()}
                                                                                            </div>
                                                                                            <div className={`text-xs px-1 py-0.5 rounded mt-1 inline-block ${
                                                                                                payments[3].status === 'succeeded' 
                                                                                                    ? 'bg-green-100 text-green-800'
                                                                                                    : payments[3].status === 'failed'
                                                                                                        ? 'bg-red-100 text-red-800'
                                                                                                    : payments[3].status === 'canceled'
                                                                                                        ? 'bg-orange-100 text-orange-800'
                                                                                                        : payments[3].status === 'processing'
                                                                                                            ? 'bg-blue-100 text-blue-800'
                                                                                                            : 'bg-yellow-100 text-yellow-800'
                                                                                            }`}>
                                                                                                {payments[3].status}
                                                                                            </div>
                                                                                        </div>
                                                                                    ) : '—'}
                                                                                </td>
                                                                                
                                                                                {/* Status */}
                                                                                <td className={`px-3 py-2 text-center font-semibold text-xs ${
                                                                                    subscription 
                                                                                        ? subscription.status === 'active' 
                                                                                            ? 'bg-green-100 text-green-800' 
                                                                                            : subscription.status === 'canceled' 
                                                                                                ? 'bg-red-100 text-red-800'
                                                                                                : 'bg-yellow-100 text-yellow-800'
                                                                                        : theme === 'dark' ? 'bg-gray-700 text-gray-300' : 'bg-gray-100 text-gray-700'
                                                                                } ${
                                                                                    theme === 'dark' && subscription
                                                                                        ? subscription.status === 'active' ? 'bg-green-900 text-green-300' : subscription.status === 'canceled' ? 'bg-red-900 text-red-300' : 'bg-yellow-900 text-yellow-300'
                                                                                        : ''
                                                                                }`}>
                                                                                    {subscription ? subscription.status : 'None'}
                                                                                </td>
                                                                                
                                                                                {/* Relationship */}
                                                                                {/* <td className={`px-3 py-2 text-center text-xs ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
                                                                                    {subscription ? 'Active' : 'Inactive'}
                                                                                </td> */}
                                                                            </tr>
                                                                        );
                                                                    })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            );
                                        })()}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    </LoadingOverlay>
                )
            }
            {
                tab === "logoSettings" && (
                    <LoadingOverlay isLoading={isLoading}>
                        <div className="p-4 pb-8">
                            <div className={`shadow rounded-lg border mb-4 ${
                                theme === 'dark' ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
                            }`}>
                                <div className={`bg-blue-500 px-4 py-3 border-b ${
                                    theme === 'dark' ? 'border-gray-700' : 'border-gray-200'
                                }`}>
                                    <h3 className="text-lg font-semibold text-white">Logo Settings</h3>
                                </div>
                                <div className="p-4">
                                    <div className="mb-4">
                                        <label className={`block text-sm font-medium mb-2 ${
                                            theme === 'dark' ? 'text-gray-300' : 'text-gray-700'
                                        }`}>Upload Logo:</label>
                                        <div className="relative">
                                            <input
                                                type="file"
                                                accept="image/*"
                                                disabled={isSecAdmin}
                                                onChange={handleLogoUpload}
                                                className="hidden"
                                                id="logo-upload-input"
                                            />
                                            <label
                                                htmlFor="logo-upload-input"
                                                className={`flex items-center justify-center gap-2 w-full px-4 py-2.5 border-2 border-dashed rounded-lg cursor-pointer transition-all ${
                                                    theme === 'dark' 
                                                        ? 'bg-gray-700 text-white border-gray-600 hover:bg-gray-600 hover:border-blue-500' 
                                                        : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50 hover:border-blue-500'
                                                } ${isSecAdmin ? 'opacity-50 cursor-not-allowed' : ''}`}
                                            >
                                                <FaUpload className="text-lg" />
                                                <span className="text-sm font-medium">Choose File</span>
                                            </label>
                                        </div>
                                    </div>
                                    {logoUrl && (
                                        <div className={`mb-4 p-3 border rounded ${
                                            theme === 'dark' ? 'bg-gray-700 border-gray-600' : 'bg-gray-50 border-gray-200'
                                        }`}>
                                            <p className={`text-sm font-medium mb-2 ${
                                                theme === 'dark' ? 'text-gray-300' : 'text-gray-700'
                                            }`}>Current Logo:</p>
                                            <img src={logoUrl} alt="Gym Logo" className="max-w-xs" />
                                        </div>
                                    )}
                                    <Button
                                        onClick={handleSaveLogo}
                                        disabled={isSecAdmin}
                                        type="primary"
                                        size="large"
                                        className="bg-blue-500 hover:bg-blue-600 flex items-center gap-2"
                                        icon={<FaSave />}
                                    >
                                        Save Logo
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </LoadingOverlay>
                )
            }

            {
                tab === "bookingSettings" && (
                    <LoadingOverlay isLoading={isLoading}>
                        <div className="p-4 pb-8">
                            <div className={`shadow rounded-lg border mb-4 ${
                                theme === 'dark' ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
                            }`}>
                                <div className={`bg-blue-500 px-4 py-3 border-b ${
                                    theme === 'dark' ? 'border-gray-700' : 'border-gray-200'
                                }`}>
                                    <h3 className="text-lg font-semibold text-white">Class Booking Settings</h3>
                                </div>
                                <div className="p-4">
                                    <div className="mb-4">
                                        <label htmlFor="bookingDays" className={`block text-sm font-medium mb-2 ${
                                            theme === 'dark' ? 'text-gray-300' : 'text-gray-700'
                                        }`}>
                                            Days Prior to Allow Booking:
                                        </label>
                                        <div className={theme === 'dark' ? 'dark-select' : ''}>
                                        <Select
                                            id="bookingDays"
                                            value={bookingDays}
                                            disabled={isSecAdmin}
                                            onChange={setBookingDays}
                                            className="w-full"
                                            dropdownClassName={theme === 'dark' ? 'dark-select-dropdown' : ''}
                                            size="large"
                                        >
                                            {[...Array(31)].map((_, i) => (
                                                <Select.Option key={i} value={i + 1}>
                                                    {i + 1} day{i !== 0 ? "s" : ""}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                        </div>
                                    </div>
                                    <div className="mb-4">
                                        <label htmlFor="hoursBeforeBookingClose" className={`block text-sm font-medium mb-2 ${
                                            theme === 'dark' ? 'text-gray-300' : 'text-gray-700'
                                        }`}>
                                            Hours Before Class Start to Close Bookings:
                                        </label>
                                        <div className={theme === 'dark' ? 'dark-select' : ''}>
                                        <Select
                                            id="minutesBeforeBookingClose"
                                            value={hoursBeforeBookingClose}
                                            disabled={isSecAdmin}
                                            onChange={setHoursBeforeBookingClose}
                                            className="w-full"
                                            dropdownClassName={theme === 'dark' ? 'dark-select-dropdown' : ''}
                                            size="large"
                                        >
                                            {minuteOptions.map(min => (
                                                <Select.Option key={min} value={min}>
                                                    {min} minutes
                                                </Select.Option>
                                            ))}

                                            {[...Array(24)].map((_, h) =>
                                                minuteOptions.map(m => {
                                                    if (h === 0 && m === 0) return null;

                                                    const totalMinutes = h * 60 + m;

                                                    return (
                                                        <Select.Option key={`${h}-${m}`} value={totalMinutes}>
                                                            {h > 0 && `${h} hour${h > 1 ? "s" : ""}`}
                                                            {h > 0 && m > 0 && " "}
                                                            {m > 0 && `${m} minutes`}
                                                        </Select.Option>
                                                    );
                                                })
                                            )}
                                        </Select>
                                        </div>
                                    </div>
                                    <Button
                                        onClick={handleSaveBookingDays}
                                        disabled={isSecAdmin}
                                        type="primary"
                                        size="large"
                                        className="bg-blue-500 hover:bg-blue-600 flex items-center gap-2"
                                        icon={<FaSave />}
                                    >
                                        Save Booking Settings
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </LoadingOverlay>
                )
            }

            {
                tab === "agreement" && (
                    <LoadingOverlay isLoading={isLoading}>
                        <div className="p-3 sm:p-4 lg:p-6 h-full overflow-auto">
                            <AgreementUpload isSecAdmin={isSecAdmin} theme={theme} />
                        </div>
                    </LoadingOverlay>
                )
            }

            {
                tab === "staff_report" && (
                    <div className="p-3 sm:p-4 lg:p-6 h-full overflow-auto">
                    <StaffReport isSecAdmin={isSecAdmin} theme={theme}></StaffReport>
                    </div>
                )
            }

            {
                tab === "member_report" && (
                    <div className="p-3 sm:p-4 lg:p-6 h-full overflow-auto">
                    <MemberReport theme={theme}></MemberReport>
                    </div>
                )
            }
            {tab === "membershipDetails" && <div className="p-3 sm:p-4 lg:p-6 h-full overflow-auto"><MembershipDetailsTab isSecAdmin={isSecAdmin} theme={theme}></MembershipDetailsTab></div>}

            {tab === "bookings" && <div className="p-3 sm:p-4 lg:p-6 h-full overflow-auto"><BookingDetails theme={theme} /></div>}

            {tab === "archive" && <div className="p-3 sm:p-4 lg:p-6 h-full overflow-auto"><ArchivedMembersPage theme={theme}></ArchivedMembersPage></div>}
            {tab === "archivedCoaches" && <div className="p-3 sm:p-4 lg:p-6 h-full overflow-auto"><ArchivedCoachesPage onRestore={() => fetchCoaches()} theme={theme}></ArchivedCoachesPage></div>}

            {
                tab === "secAdmin" && (
                    <LoadingOverlay isLoading={isLoading}>
                        <div className="p-3 sm:p-4 lg:p-6 h-full overflow-auto">
                        <div className="overflow-x-auto overflow-y-visible">
                            <table className="w-full text-sm">
                                <thead>
                                    <tr className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-lg shadow-lg p-6 sm:p-8 mb-6">
                                        <th className="px-4 py-2 text-left text-white">Name</th>
                                        <th className="px-4 py-2 text-left text-white">Email</th>
                                        <th className="px-4 py-2 text-left text-white">Phone</th>
                                        <th className="px-4 py-2 text-left text-white">Is Assistant Admin ?</th>
                                        <th className="px-4 py-2 text-left text-white">Is Active Admin?</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {secAdmins.map((secAdmin) => (
                                        <tr key={secAdmin.id} className={`border-b ${
                                            theme === 'dark' ? 'border-gray-700' : ''
                                        }`}>
                                            <td className={`px-4 py-2 ${
                                                theme === 'dark' ? 'text-gray-200' : 'text-gray-900'
                                            }`}>{secAdmin.fullName}</td>
                                            <td className={`px-4 py-2 ${
                                                theme === 'dark' ? 'text-gray-200' : 'text-gray-900'
                                            }`}>{secAdmin.email}</td>
                                            <td className={`px-4 py-2 ${
                                                theme === 'dark' ? 'text-gray-200' : 'text-gray-900'
                                            }`}>{secAdmin.phone}</td>
                                            <td className="px-4 py-2">
                                                <label className="flex items-center cursor-pointer">
                                                    <div className="relative">
                                                        <input
                                                            type="checkbox"
                                                            className="sr-only"
                                                            checked={secAdmin.isSecAdmin}
                                                            disabled={isSecAdmin}
                                                            onChange={() => handleToggleSecAdmin(secAdmin.id)}
                                                        />
                                                        <div className={`block w-14 h-8 rounded-full ${secAdmin.isSecAdmin ? 'bg-green-400' : 'bg-gray-400'}`}></div>
                                                        <div className={`absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition-transform ${secAdmin.isSecAdmin ? 'transform translate-x-6' : ''}`}></div>
                                                    </div>
                                                    <span className={`ml-3 text-sm font-medium ${
                                                        theme === 'dark' ? 'text-gray-200' : 'text-gray-900'
                                                    }`}>
                                                        {secAdmin.isSecAdmin ? 'Yes' : 'No'}
                                                    </span>
                                                </label>
                                            </td>
                                            <td className="px-4 py-2">
                                                <label className="flex items-center cursor-pointer">
                                                    <div className="relative">
                                                        <input
                                                            type="checkbox"
                                                            className="sr-only"
                                                            checked={secAdmin.isActiveAdmin}
                                                            disabled={isSecAdmin}
                                                            onChange={() => handleInactiveSecAdmin(secAdmin.id)}
                                                        />
                                                        <div className={`block w-14 h-8 rounded-full ${secAdmin.isActiveAdmin ? 'bg-green-400' : 'bg-gray-400'}`}></div>
                                                        <div className={`absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition-transform ${secAdmin.isActiveAdmin ? 'transform translate-x-6' : ''}`}></div>
                                                    </div>
                                                    <span className={`ml-3 text-sm font-medium ${
                                                        theme === 'dark' ? 'text-gray-200' : 'text-gray-900'
                                                    }`}>
                                                        {secAdmin.isActiveAdmin ? 'Yes' : 'No'}
                                                    </span>
                                                </label>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        </div>
                    </LoadingOverlay>

                )
            }
            {tab === "categories" && (
                <div className="flex-1 overflow-auto">
                    <CategoryManagement isSecAdmin={isSecAdmin} theme={theme} onCategoriesChange={fetchCategories} />
                </div>
            )}

            {tab === "classPerformanceReport" && (
                <div className="flex-1 overflow-auto">
                    <ClassPerformanceReport theme={theme} />
                </div>
            )}

            <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)}>
                <p>{modalMessage}</p>
            </Modal>
                </div>
            </div>
        </div >
    );
}